<body>
    <div class="container">
        <table class="table-selects">
            <thead>
                <tr>
                    <th class="flex">
                        <div class="divHeader">
                            <input class="largo" type="date" name="dataExibirPre" [(ngModel)]="dataExibirPre">
                            <button class="atualizar" (click)="atualizaData()">Atualizar</button>
                        </div>
                        <div class="divHeader central">
                            <h1>TIME TABLE SCANIA SBC</h1>
                        </div>
                        <div class="divHeader">
                            <button class="btn-frete icone-setting R27" mat-button
                                (click)="exportToExcel(timeTableGeral,'R27')"><i-feather name="printer"></i-feather>
                                R27/R29</button>
                            <button class="btn-frete icone-setting R16" mat-button
                                (click)="exportToExcel(timeTableGeral,'R16')"><i-feather name="printer"></i-feather>
                                R16</button>
                            <button class="btn-frete icone-setting R3" mat-button
                                (click)="exportToExcel(timeTableGeral,'R3')"><i-feather name="printer"></i-feather>
                                R3</button>
                            <button class="btn-frete icone-setting R26" mat-button
                                (click)="exportToExcel(timeTableGeral,'R26')"><i-feather name="printer"></i-feather>
                                R26</button>
                            <button class="btn-frete icone-setting R4" mat-button
                                (click)="exportToExcel(timeTableGeral,'R4')"><i-feather name="printer"></i-feather>
                                R4</button>
                            <button class="btn-frete icone-setting R40" mat-button
                                (click)="exportToExcel(timeTableGeral,'R40')"><i-feather name="printer"></i-feather>
                                R40</button>
                            <button class="btn-frete icone-setting R54" mat-button
                                (click)="exportToExcel(timeTableGeral,'R54')"><i-feather name="printer"></i-feather>
                                R54</button>
                            <button class="btn-frete icone-setting E56" mat-button
                                (click)="exportToExcel(timeTableGeral,'E56')"><i-feather name="printer"></i-feather>
                                E56</button>
                            <button class="btn-frete icone-setting R56" mat-button
                                (click)="exportToExcel(timeTableGeral,'R56')"><i-feather name="printer"></i-feather>
                                R56</button>
                            <button class="btn-frete icone-setting E37" mat-button
                                (click)="exportToExcel(timeTableGeral,'E37')"><i-feather name="printer"></i-feather>
                                E37</button>
                            <button class="btn-frete icone-setting R43" mat-button
                                (click)="exportToExcel(timeTableGeral,'R43')"><i-feather name="printer"></i-feather>
                                R43</button>
                            <button class="btn-frete icone-setting R22" mat-button
                                (click)="exportToExcel(timeTableGeral,'R22')"><i-feather name="printer"></i-feather>
                                R22</button>
                        </div>
                    </th>
                </tr>
            </thead>
        </table>
        <table>
            <thead>
                <tr>
                    <th class="flexEdit">
                        <div class="data">
                            <span>{{ dataExibir | date : 'dd/MM/yyyy' }}</span>
                        </div>
                        <div class="flex1">
                            Selecione as áreas que deseja visualizar
                            <input type="checkbox" [(ngModel)]="R27"> R27/R29
                            <input type="checkbox" [(ngModel)]="R16"> R16
                            <input type="checkbox" [(ngModel)]="R3"> R3
                            <input type="checkbox" [(ngModel)]="R26"> R26
                            <input type="checkbox" [(ngModel)]="R4"> R4
                            <input type="checkbox" [(ngModel)]="R40"> R40
                            <input type="checkbox" [(ngModel)]="R54"> R54
                            <input type="checkbox" [(ngModel)]="E56"> E56
                            <input type="checkbox" [(ngModel)]="E37"> E37
                            <input type="checkbox" [(ngModel)]="R56"> R56
                            <input type="checkbox" [(ngModel)]="R43"> R43
                            <input type="checkbox" [(ngModel)]="R22"> R22
                        </div>
                    </th>
                </tr>
            </thead>
        </table>

        <div class="table-container scrollable-container">
            <table class="geralTable">
                <thead class="sticky-header">
                    <tr>
                        <th class="titulo-coluna" colspan="1">
                            <span class="semFundo">HORÁRIO</span>
                        </th>
                        <th *ngIf="R27" class="R27 titulo-coluna" colspan="5">
                            <span class="semFundo">R27/R29</span>
                        </th>
                        <th *ngIf="R16" class="R16 titulo-coluna" colspan="1">
                            <span class="semFundo">R16</span>
                        </th>
                        <th *ngIf="R3" class="R3 titulo-coluna" colspan="2">
                            <span class="semFundo">R3</span>
                        </th>
                        <th *ngIf="R26" class="R26 titulo-coluna" colspan="1">
                            <span class="semFundo">R26</span>
                        </th>
                        <th *ngIf="R4" class="R4 titulo-coluna" colspan="1">
                            <span class="semFundo">R4</span>
                        </th>
                        <th *ngIf="R40" class="R40 titulo-coluna" colspan="2">
                            <span class="semFundo">R40</span>
                        </th>
                        <th *ngIf="R54" class="R54 titulo-coluna" colspan="2">
                            <span class="semFundo">R54</span>
                        </th>
                        <th *ngIf="E56" class="E56 titulo-coluna" colspan="4">
                            <span class="semFundo">E56</span>
                        </th>
                        <th *ngIf="E37" class="E37 titulo-coluna" colspan="4">
                            <span class="semFundo">E37</span>
                        </th>
                        <th *ngIf="R56" class="R56 titulo-coluna" colspan="2">
                            <span class="semFundo">R56</span>
                        </th>
                        <th *ngIf="R43" class="R43 titulo-coluna" colspan="1">
                            <span class="semFundo">R43</span>
                        </th>
                        <th *ngIf="R22" class="R22 titulo-coluna" colspan="2">
                            <span class="semFundo">R22</span>
                        </th>
                    </tr>
                </thead>
                <tbody *ngFor="let _ of [].constructor(24); let i = index">
                    <tr class="corpoTimeTable">
                        <td class="centralizado" [ngClass]="classHora ? classHora[i] : ''"><br>
                            <!-- <abbr style="color: #cccbc9; font-size: 4.5vh; font-weight: bold;">{{ dataExibir | date :
                                'dd/MM' }}</abbr><br> -->
                            <abbr style="color: #cccbc9; font-size: 3.5vh; font-weight: bold;"> {{ getFormattedDate(i,
                                dataExibir) }}:00 </abbr><br>
                            <span *ngIf="R27"> <abbr
                                    style="color: #000000; font-size: 1.8vh; font-weight: bold;">R27/R29:
                                </abbr> {{ valorItemVolume[i][0].toFixed(2) }}</span><br>
                            <span *ngIf="R16"> <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">R16:
                                </abbr> {{ valorItemVolume[i][1].toFixed(2) + valorItemVolume[i][11].toFixed(2)
                                }}</span><br>
                            <span *ngIf="R26"> <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">R26:
                                </abbr> {{ valorItemVolume[i][2].toFixed(2) }} </span><br>
                            <span *ngIf="R4"> <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">R4:
                                </abbr> {{ valorItemVolume[i][3].toFixed(2) }} </span><br>
                            <span *ngIf="R40"><abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">R40:
                                </abbr> {{ valorItemVolume[i][4].toFixed(2) }} </span><br>
                            <span *ngIf="R54"><abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">R54:
                                </abbr> {{ valorItemVolume[i][5].toFixed(2) }} </span><br>
                            <span *ngIf="E56"><abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">E56:
                                </abbr> {{ valorItemVolume[i][6].toFixed(2) }} </span><br>
                            <span *ngIf="E37"><abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">E37:
                                </abbr> {{ valorItemVolume[i][7].toFixed(2) }} </span><br>
                            <span *ngIf="R56"><abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">R56:
                                </abbr> {{ valorItemVolume[i][8].toFixed(2) }} </span><br>
                            <span *ngIf="R43"><abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">R43:
                                </abbr> {{ valorItemVolume[i][9].toFixed(2) }} </span>
                            <span *ngIf="R22"><abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">R22:
                                </abbr> {{ valorItemVolume[i][10].toFixed(2) }} </span>
                        </td>
                        <!-- <td class="volumes">Volumes: </td> -->
                        <td [ngClass]="timeTableGeral[i]['R27'][0]?.statusEntrega"
                            (click)="timeTableGeral[i]['R27'][0] ? editDialog(timeTableGeral[i]['R27'][0]) : editDialog2('R27')"
                            *ngIf="R27">
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R27'][0]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> ID:
                                    </abbr>
                                    {{ timeTableGeral[i]['R27'][0]?.ID }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R27'][0]?.created"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> Created:
                                    </abbr>
                                    {{ timeTableGeral[i]['R27'][0]?.created | date : 'dd/MM/yyyy HH:mm' }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R27'][0]?.lastUpdate"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> Last Update.:
                                    </abbr>
                                    {{ timeTableGeral[i]['R27'][0]?.lastUpdate | date : 'dd/MM/yyyy HH:mm' }} by {{ timeTableGeral[i]['R27'][0]?.UpdateByUser }} </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['R27'][0]?.idContainer" class="infos">
                                <span *ngIf="timeTableGeral[i]['R27'][0]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container: </abbr>
                                    {{ timeTableGeral[i]['R27'][0]?.ID }}<br> </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['R27'][0]?.CTNRAlugado" class="infos">
                                <span *ngIf="timeTableGeral[i]['R27'][0]?.CTNRAlugado"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container Alugado:
                                    </abbr>
                                    {{ timeTableGeral[i]['R27'][0]?.CTNRAlugado }}<br> </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['R27'][0]?.viagem" class="infos">
                                <span *ngIf="timeTableGeral[i]['R27'][0]?.viagem"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Viagem:
                                    </abbr>
                                    {{ timeTableGeral[i]['R27'][0]?.viagem }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R27'][0]?.Transportadora"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Transp.: </abbr>
                                    {{ timeTableGeral[i]['R27'][0]?.Transportadora }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R27'][0]?.Plate "><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> Placa: </abbr>
                                    {{ timeTableGeral[i]['R27'][0]?.Plate }}</span>
                            </div>
                            <div class="infos">
                                <span class="fornecedores" *ngIf="timeTableGeral[i]['R27'][0]?.Fornecedores"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Fornecedores:
                                    </abbr>
                                    {{ timeTableGeral[i]['R27'][0]?.Fornecedores }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R27'][0]?.Volumes"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Volumes: </abbr>
                                    {{ timeTableGeral[i]['R27'][0]?.Volumes }}</span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R27'][0]?.SequenciaSCANIA"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Registro: </abbr>
                                    {{ timeTableGeral[i]['R27'][0]?.SequenciaSCANIA }}</span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R27'][0]?.pecasCritica"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Peças Críticas:
                                    </abbr>
                                    <span class="pnCritica"
                                        *ngFor="let pecas of timeTableGeral[i]['R27'][0]?.pecasCritica">
                                        {{ pecas.PN }}</span>
                                </span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['R27'][0] && (timeTableGeral[i]['R27'][0].chegada || timeTableGeral[i]['R27'][0].ChegadaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Chegada: </abbr>
                                    {{ timeTableGeral[i]['R27'][0].chegada ? (timeTableGeral[i]['R27'][0]?.chegada |
                                    date : 'dd/MM/yyyy HH:mm' : '+00:00') :
                                    (timeTableGeral[i]['R27'][0]?.ChegadaSCANIA | date :
                                    'dd/MM/yyyy HH:mm') }}
                                </span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['R27'][0] && (timeTableGeral[i]['R27'][0].entrada || timeTableGeral[i]['R27'][0].EntradaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Entrada: </abbr>
                                    {{ timeTableGeral[i]['R27'][0].entrada ? (timeTableGeral[i]['R27'][0].entrada | date
                                    : 'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['R27'][0]?.EntradaSCANIA | date :
                                    'dd/MM/yyyy HH:mm') }}
                                </span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['R27'][0] && (timeTableGeral[i]['R27'][0].saida || timeTableGeral[i]['R27'][0].SaidaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Saida: </abbr>
                                    {{ timeTableGeral[i]['R27'][0].saida ? (timeTableGeral[i]['R27'][0].saida | date :
                                    'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['R27'][0]?.SaidaSCANIA | date :
                                    'dd/MM/yyyy HH:mm') }}
                                </span>
                            </div>
                        </td>
                        <td [ngClass]="timeTableGeral[i]['R27'][1]?.statusEntrega"
                            (click)="timeTableGeral[i]['R27'][1] ? editDialog(timeTableGeral[i]['R27'][1]) : editDialog2('R27')"
                            *ngIf="R27">
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R27'][1]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> ID:
                                    </abbr>
                                    {{ timeTableGeral[i]['R27'][1]?.ID }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R27'][1]?.created"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> Created:
                                    </abbr>
                                    {{ timeTableGeral[i]['R27'][1]?.created | date : 'dd/MM/yyyy HH:mm' }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R27'][1]?.lastUpdate"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Last Update.:
                                    </abbr>
                                    {{ timeTableGeral[i]['R27'][1]?.lastUpdate | date : 'dd/MM/yyyy HH:mm' }} by {{ timeTableGeral[i]['R27'][1]?.UpdateByUser }} </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['R27'][1]?.idContainer" class="infos">
                                <span *ngIf="timeTableGeral[i]['R27'][1]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container: </abbr>
                                    {{ timeTableGeral[i]['R27'][1]?.ID }}<br> </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['R27'][1]?.CTNRAlugado" class="infos">
                                <span *ngIf="timeTableGeral[i]['R27'][1]?.CTNRAlugado"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container Alugado:
                                    </abbr>
                                    {{ timeTableGeral[i]['R27'][1]?.CTNRAlugado }}<br> </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['R27'][1]?.viagem" class="infos">
                                <span *ngIf="timeTableGeral[i]['R27'][1]?.viagem"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Viagem:
                                    </abbr>
                                    {{ timeTableGeral[i]['R27'][1]?.viagem }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R27'][1]?.Transportadora"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Transp.: </abbr>
                                    {{ timeTableGeral[i]['R27'][1]?.Transportadora }}</span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R27'][1]?.Plate "><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Placa: </abbr>
                                    {{ timeTableGeral[i]['R27'][1]?.Plate }} </span>
                            </div>
                            <div class="infos">
                                <span class="fornecedores" *ngIf="timeTableGeral[i]['R27'][1]?.Fornecedores"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Fornecedores:
                                    </abbr>
                                    {{ timeTableGeral[i]['R27'][1]?.Fornecedores }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R27'][1]?.Volumes"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Volumes: </abbr>
                                    {{ timeTableGeral[i]['R27'][1]?.Volumes }}</span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R27'][1]?.pecasCritica"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Peças Críticas:
                                    </abbr>
                                    <span class="pnCritica"
                                        *ngFor="let pecas of timeTableGeral[i]['R27'][1]?.pecasCritica">
                                        {{ pecas.PN }}</span>
                                </span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['R27'][1] && (timeTableGeral[i]['R27'][1].chegada || timeTableGeral[i]['R27'][1].ChegadaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Chegada: </abbr>
                                    {{ timeTableGeral[i]['R27'][1]?.chegada ? (timeTableGeral[i]['R27'][1]?.chegada |
                                    date : 'dd/MM/yyyy HH:mm' : '+00:00') :
                                    (timeTableGeral[i]['R27'][1]?.ChegadaSCANIA | date :
                                    'dd/MM/yyyy HH:mm') }}
                                </span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['R27'][1] && (timeTableGeral[i]['R27'][1].entrada || timeTableGeral[i]['R27'][1].EntradaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Entrada: </abbr>
                                    {{ timeTableGeral[i]['R27'][1]?.entrada ? (timeTableGeral[i]['R27'][1]?.entrada |
                                    date : 'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['R27'][1]?.EntradaSCANIA | date :
                                    'dd/MM/yyyy HH:mm') }}
                                </span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['R27'][1] && (timeTableGeral[i]['R27'][1].saida || timeTableGeral[i]['R27'][1].SaidaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Saida: </abbr>
                                    {{ timeTableGeral[i]['R27'][1]?.saida ? (timeTableGeral[i]['R27'][1]?.saida | date :
                                    'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['R27'][1]?.SaidaSCANIA | date :
                                    'dd/MM/yyyy HH:mm') }}
                                </span>
                            </div>
                        </td>
                        <td [ngClass]="timeTableGeral[i]['R27'][2]?.statusEntrega"
                            (click)="timeTableGeral[i]['R27'][2] ? editDialog(timeTableGeral[i]['R27'][2]) : editDialog2('R27')"
                            *ngIf="R27">
                            <div class="infos">
                                <div class="infos">
                                    <span *ngIf="timeTableGeral[i]['R27'][2]?.ID"><abbr
                                            style="color: #000000; font-size: 1.8vh; font-weight: bold;"> ID:
                                        </abbr>
                                        {{ timeTableGeral[i]['R27'][2]?.ID }} </span>
                                </div>
                                <span *ngIf="timeTableGeral[i]['R27'][2]?.created"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> Created:
                                    </abbr>
                                    {{ timeTableGeral[i]['R27'][2]?.created | date : 'dd/MM/yyyy HH:mm' }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R27'][2]?.lastUpdate"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Last Update.:
                                    </abbr>
                                    {{ timeTableGeral[i]['R27'][2]?.lastUpdate | date : 'dd/MM/yyyy HH:mm' }} by {{ timeTableGeral[i]['R27'][2]?.UpdateByUser }}  </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['R27'][2]?.idContainer" class="infos">
                                <span *ngIf="timeTableGeral[i]['R27'][2]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container: </abbr>
                                    {{ timeTableGeral[i]['R27'][2]?.ID }}<br> </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['R27'][2]?.CTNRAlugado" class="infos">
                                <span *ngIf="timeTableGeral[i]['R27'][2]?.CTNRAlugado"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container Alugado:
                                    </abbr>
                                    {{ timeTableGeral[i]['R27'][2]?.CTNRAlugado }}<br> </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['R27'][2]?.viagem" class="infos">
                                <span *ngIf="timeTableGeral[i]['R27'][2]?.viagem"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Viagem:
                                    </abbr>
                                    {{ timeTableGeral[i]['R27'][2]?.viagem }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R27'][2]?.Transportadora"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Transp.: </abbr>
                                    {{ timeTableGeral[i]['R27'][2]?.Transportadora }}</span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R27'][2]?.Plate "> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Placa: </abbr>
                                    {{ timeTableGeral[i]['R27'][2]?.Plate }}<br> </span>
                            </div>
                            <div class="infos">
                                <span class="fornecedores" *ngIf="timeTableGeral[i]['R27'][2]?.Fornecedores"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Fornecedores:
                                    </abbr>
                                    {{ timeTableGeral[i]['R27'][2]?.Fornecedores }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R27'][2]?.Volumes"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Volumes:</abbr>
                                    {{ timeTableGeral[i]['R27'][2]?.Volumes }}</span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R27'][2]?.pecasCritica"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Peças Críticas:
                                    </abbr>
                                    <span class="pnCritica"
                                        *ngFor="let pecas of timeTableGeral[i]['R27'][2]?.pecasCritica">
                                        {{ pecas.PN }}</span>
                                </span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['R27'][2] && (timeTableGeral[i]['R27'][2].chegada || timeTableGeral[i]['R27'][2].ChegadaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Chegada: </abbr>
                                    {{ timeTableGeral[i]['R27'][2]?.chegada ? (timeTableGeral[i]['R27'][2]?.chegada |
                                    date : 'dd/MM/yyyy HH:mm' : '+00:00') :
                                    (timeTableGeral[i]['R27'][2]?.ChegadaSCANIA | date :
                                    'dd/MM/yyyy HH:mm') }}
                                </span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['R27'][2] && (timeTableGeral[i]['R27'][2].entrada || timeTableGeral[i]['R27'][2].EntradaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Entrada: </abbr>
                                    {{ timeTableGeral[i]['R27'][2]?.entrada ? (timeTableGeral[i]['R27'][2]?.entrada |
                                    date : 'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['R27'][2]?.EntradaSCANIA | date :
                                    'dd/MM/yyyy HH:mm') }}
                                </span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['R27'][2] && (timeTableGeral[i]['R27'][2].saida || timeTableGeral[i]['R27'][2].SaidaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Saida:</abbr>
                                    {{ timeTableGeral[i]['R27'][2]?.saida ? (timeTableGeral[i]['R27'][2]?.saida | date :
                                    'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['R27'][2]?.SaidaSCANIA | date :
                                    'dd/MM/yyyy HH:mm') }}
                                </span>
                            </div>
                        </td>
                        <td [ngClass]="timeTableGeral[i]['R27'][3]?.statusEntrega"
                            (click)="timeTableGeral[i]['R27'][3] ? editDialog(timeTableGeral[i]['R27'][3]) : editDialog2('R27')"
                            *ngIf="R27">
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R27'][3]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> ID:
                                    </abbr>
                                    {{ timeTableGeral[i]['R27'][3]?.ID }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R27'][3]?.created"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> Created:
                                    </abbr>
                                    {{ timeTableGeral[i]['R27'][3]?.created | date : 'dd/MM/yyyy HH:mm' }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R27'][3]?.lastUpdate"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Last Update.:
                                    </abbr>
                                    {{ timeTableGeral[i]['R27'][3]?.lastUpdate | date : 'dd/MM/yyyy HH:mm' }} by {{ timeTableGeral[i]['R27'][3]?.UpdateByUser }} 
                                </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['R27'][3]?.idContainer" class="infos">
                                <span *ngIf="timeTableGeral[i]['R27'][3]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container: </abbr>
                                    {{ timeTableGeral[i]['R27'][3]?.ID }}<br> </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['R27'][3]?.CTNRAlugado" class="infos">
                                <span *ngIf="timeTableGeral[i]['R27'][3]?.CTNRAlugado"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container Alugado:
                                    </abbr>
                                    {{ timeTableGeral[i]['R27'][3]?.CTNRAlugado }}<br> </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['R27'][3]?.viagem" class="infos">
                                <span *ngIf="timeTableGeral[i]['R27'][3]?.viagem"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Viagem:
                                    </abbr>
                                    {{ timeTableGeral[i]['R27'][3]?.viagem }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R27'][3]?.Transportadora"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Transp.: </abbr>
                                    {{ timeTableGeral[i]['R27'][3]?.Transportadora }} <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R27'][3]?.Plate "> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Placa: </abbr>
                                    {{ timeTableGeral[i]['R27'][3]?.Plate }} <br></span>
                            </div>
                            <div class="infos">
                                <span class="fornecedores" *ngIf="timeTableGeral[i]['R27'][3]?.Fornecedores"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Fornecedores:
                                    </abbr>
                                    {{ timeTableGeral[i]['R27'][3]?.Fornecedores }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R27'][3]?.Volumes"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Volumes: </abbr>
                                    {{ timeTableGeral[i]['R27'][3]?.Volumes }} <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R27'][3]?.pecasCritica"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Peças Críticas:
                                    </abbr>
                                    <span class="pnCritica"
                                        *ngFor="let pecas of timeTableGeral[i]['R27'][3]?.pecasCritica">
                                        {{ pecas.PN }}</span>
                                </span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['R27'][3] && (timeTableGeral[i]['R27'][3].chegada || timeTableGeral[i]['R27'][3].ChegadaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Chegada: </abbr>
                                    {{ timeTableGeral[i]['R27'][3]?.chegada ? (timeTableGeral[i]['R27'][3]?.chegada |
                                    date : 'dd/MM/yyyy HH:mm' : '+00:00') :
                                    (timeTableGeral[i]['R27'][3]?.ChegadaSCANIA | date :
                                    'dd/MM/yyyy HH:mm')}}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['R27'][3] && (timeTableGeral[i]['R27'][3].entrada || timeTableGeral[i]['R27'][3].EntradaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Entrada: </abbr>
                                    {{ timeTableGeral[i]['R27'][3]?.entrada ? (timeTableGeral[i]['R27'][3]?.entrada |
                                    date : 'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['R27'][3]?.EntradaSCANIA | date :
                                    'dd/MM/yyyy HH:mm')}}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['R27'][3] && (timeTableGeral[i]['R27'][3].saida || timeTableGeral[i]['R27'][3].SaidaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Saida: </abbr>
                                    {{ timeTableGeral[i]['R27'][3]?.saida ? (timeTableGeral[i]['R27'][3]?.saida | date :
                                    'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['R27'][3]?.SaidaSCANIA | date :
                                    'dd/MM/yyyy HH:mm')}}
                                </span>
                            </div>
                        </td>
                        <td [ngClass]="timeTableGeral[i]['R27'][4]?.statusEntrega"
                            (click)="timeTableGeral[i]['R27'][4] ? editDialog(timeTableGeral[i]['R27'][4]) : editDialog2('R27')"
                            *ngIf="R27">
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R27'][4]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> ID:
                                    </abbr>
                                    {{ timeTableGeral[i]['R27'][4]?.ID }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R27'][4]?.created"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> Created:
                                    </abbr>
                                    {{ timeTableGeral[i]['R27'][4]?.created | date : 'dd/MM/yyyy HH:mm' }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R27'][4]?.lastUpdate"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Last Update.:
                                    </abbr>
                                    {{ timeTableGeral[i]['R27'][4]?.lastUpdate | date : 'dd/MM/yyyy HH:mm' }} by {{ timeTableGeral[i]['R27'][4]?.UpdateByUser }} 
                                </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['R27'][4]?.idContainer" class="infos">
                                <span *ngIf="timeTableGeral[i]['R27'][4]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container: </abbr>
                                    {{ timeTableGeral[i]['R27'][4]?.ID }}<br> </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['R27'][4]?.CTNRAlugado" class="infos">
                                <span *ngIf="timeTableGeral[i]['R27'][4]?.CTNRAlugado"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container Alugado:
                                    </abbr>
                                    {{ timeTableGeral[i]['R27'][4]?.CTNRAlugado }}<br> </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['R27'][4]?.viagem" class="infos">
                                <span *ngIf="timeTableGeral[i]['R27'][4]?.viagem"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Viagem:
                                    </abbr>
                                    {{ timeTableGeral[i]['R27'][4]?.viagem }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R27'][4]?.Transportadora"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Transp.: </abbr>
                                    {{ timeTableGeral[i]['R27'][4]?.Transportadora }} <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R27'][4]?.Plate "> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Placa: </abbr>
                                    {{ timeTableGeral[i]['R27'][4]?.Plate }} <br></span>
                            </div>
                            <div class="infos">
                                <span class="fornecedores" *ngIf="timeTableGeral[i]['R27'][4]?.Fornecedores"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Fornecedores:
                                    </abbr>
                                    {{ timeTableGeral[i]['R27'][4]?.Fornecedores }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R27'][4]?.Volumes"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Volumes: </abbr>
                                    {{ timeTableGeral[i]['R27'][4]?.Volumes }} <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R27'][4]?.pecasCritica"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Peças Críticas:
                                    </abbr>
                                    <span class="pnCritica"
                                        *ngFor="let pecas of timeTableGeral[i]['R27'][4]?.pecasCritica">
                                        {{ pecas.PN }}</span>
                                </span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['R27'][4] && (timeTableGeral[i]['R27'][4].chegada || timeTableGeral[i]['R27'][4].ChegadaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Chegada: </abbr>
                                    {{ timeTableGeral[i]['R27'][4]?.chegada ? (timeTableGeral[i]['R27'][4]?.chegada |
                                    date : 'dd/MM/yyyy HH:mm' : '+00:00') :
                                    (timeTableGeral[i]['R27'][4]?.ChegadaSCANIA | date :
                                    'dd/MM/yyyy HH:mm')}}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['R27'][4] && (timeTableGeral[i]['R27'][4].entrada || timeTableGeral[i]['R27'][4].EntradaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Entrada: </abbr>
                                    {{ timeTableGeral[i]['R27'][4]?.entrada ? (timeTableGeral[i]['R27'][4]?.entrada |
                                    date : 'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['R27'][4]?.EntradaSCANIA | date :
                                    'dd/MM/yyyy HH:mm')}}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['R27'][4] && (timeTableGeral[i]['R27'][4].saida || timeTableGeral[i]['R27'][4].SaidaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Saida: </abbr>
                                    {{ timeTableGeral[i]['R27'][4]?.saida ? (timeTableGeral[i]['R27'][4]?.saida | date :
                                    'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['R27'][4]?.SaidaSCANIA | date :
                                    'dd/MM/yyyy HH:mm')}}
                                </span>
                            </div>
                        </td>


                        <!-- ****************************************************************************************************************************** -->


                        <td [ngClass]="timeTableGeral[i]['R16'][0]?.statusEntrega"
                            (click)="timeTableGeral[i]['R16'][0] ? editDialog(timeTableGeral[i]['R16'][0]) : editDialog2('R16')"
                            *ngIf="R16">
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R16'][0]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> ID:
                                    </abbr>
                                    {{ timeTableGeral[i]['R16'][0]?.ID }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R16'][0]?.created"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> Created:
                                    </abbr>
                                    {{ timeTableGeral[i]['R16'][0]?.created | date : 'dd/MM/yyyy HH:mm' }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R16'][0]?.lastUpdate"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> Last Update.:
                                    </abbr>
                                    {{ timeTableGeral[i]['R16'][0]?.lastUpdate | date : 'dd/MM/yyyy HH:mm' }} by {{ timeTableGeral[i]['R16'][0]?.UpdateByUser }}  </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['R16'][0]?.idContainer" class="infos">
                                <span *ngIf="timeTableGeral[i]['R16'][0]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container: </abbr>
                                    {{ timeTableGeral[i]['R16'][0]?.ID }}<br> </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['R16'][0]?.CTNRAlugado" class="infos">
                                <span *ngIf="timeTableGeral[i]['R16'][0]?.CTNRAlugado"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container Alugado:
                                    </abbr>
                                    {{ timeTableGeral[i]['R16'][0]?.CTNRAlugado }}<br> </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['R16'][0]?.viagem" class="infos">
                                <span *ngIf="timeTableGeral[i]['R16'][0]?.viagem"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Viagem:
                                    </abbr>
                                    {{ timeTableGeral[i]['R16'][0]?.viagem }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R16'][0]?.Transportadora"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Transp.: </abbr>
                                    {{ timeTableGeral[i]['R16'][0]?.Transportadora }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R16'][0]?.Plate "><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> Placa: </abbr>
                                    {{ timeTableGeral[i]['R16'][0]?.Plate }}</span>
                            </div>
                            <div class="infos">
                                <span class="fornecedores" *ngIf="timeTableGeral[i]['R16'][0]?.Fornecedores"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Fornecedores:
                                    </abbr>
                                    {{ timeTableGeral[i]['R16'][0]?.Fornecedores }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R16'][0]?.Volumes"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Volumes: </abbr>
                                    {{ timeTableGeral[i]['R16'][0]?.Volumes }}</span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R16'][0]?.pecasCritica"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Peças Críticas:
                                    </abbr>
                                    <span class="pnCritica"
                                        *ngFor="let pecas of timeTableGeral[i]['R16'][0]?.pecasCritica">
                                        {{ pecas.PN }}</span>
                                </span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['R16'][0] && (timeTableGeral[i]['R16'][0].chegada || timeTableGeral[i]['R16'][0].ChegadaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Chegada: </abbr>
                                    {{ timeTableGeral[i]['R16'][0].chegada ? (timeTableGeral[i]['R16'][0]?.chegada |
                                    date : 'dd/MM/yyyy HH:mm' : '+00:00') :
                                    (timeTableGeral[i]['R16'][0]?.ChegadaSCANIA | date :
                                    'dd/MM/yyyy HH:mm') }}
                                </span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['R16'][0] && (timeTableGeral[i]['R16'][0].entrada || timeTableGeral[i]['R16'][0].EntradaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Entrada: </abbr>
                                    {{ timeTableGeral[i]['R16'][0].entrada ? (timeTableGeral[i]['R16'][0].entrada | date
                                    : 'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['R16'][0]?.EntradaSCANIA | date :
                                    'dd/MM/yyyy HH:mm') }}
                                </span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['R16'][0] && (timeTableGeral[i]['R16'][0].saida || timeTableGeral[i]['R16'][0].SaidaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Saida: </abbr>
                                    {{ timeTableGeral[i]['R16'][0].saida ? (timeTableGeral[i]['R16'][0].saida | date :
                                    'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['R16'][0]?.SaidaSCANIA | date :
                                    'dd/MM/yyyy HH:mm') }}
                                </span>
                            </div>
                        </td>

                        <!-- //******************************************************************************************************************************************/// -->


                        <td [ngClass]="timeTableGeral[i]['R3'][0]?.statusEntrega"
                            (click)="timeTableGeral[i]['R3'][0] ? editDialog(timeTableGeral[i]['R3'][0]) : editDialog2('R3')"
                            *ngIf="R3">
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R3'][0]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> ID:
                                    </abbr>
                                    {{ timeTableGeral[i]['R3'][0]?.ID }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R3'][0]?.created"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> Created:
                                    </abbr>
                                    {{ timeTableGeral[i]['R3'][0]?.created | date : 'dd/MM/yyyy HH:mm' }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R3'][0]?.lastUpdate"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Last Update.:
                                    </abbr>
                                    {{ timeTableGeral[i]['R3'][0]?.lastUpdate | date : 'dd/MM/yyyy HH:mm' }} by {{ timeTableGeral[i]['R3'][0]?.UpdateByUser }} </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['R3'][0]?.idContainer" class="infos">
                                <span *ngIf="timeTableGeral[i]['R3'][0]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container: </abbr>
                                    {{ timeTableGeral[i]['R3'][0]?.ID }}<br> </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['R3'][0]?.CTNRAlugado" class="infos">
                                <span *ngIf="timeTableGeral[i]['R3'][0]?.CTNRAlugado"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container Alugado:
                                    </abbr>
                                    {{ timeTableGeral[i]['R3'][0]?.CTNRAlugado }}<br> </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['R3'][0]?.viagem" class="infos">
                                <span *ngIf="timeTableGeral[i]['R3'][0]?.viagem"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Viagem:
                                    </abbr>
                                    {{ timeTableGeral[i]['R3'][0]?.viagem }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R3'][0]?.Transportadora"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Transp.: </abbr>
                                    {{ timeTableGeral[i]['R3'][0]?.Transportadora }}</span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R3'][0]?.Plate "><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Placa: </abbr>
                                    {{ timeTableGeral[i]['R3'][0]?.Plate }} </span>
                            </div>
                            <div class="infos">
                                <span class="fornecedores" *ngIf="timeTableGeral[i]['R3'][0]?.Fornecedores"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Fornecedores:
                                    </abbr>
                                    {{ timeTableGeral[i]['R3'][0]?.Fornecedores }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R3'][0]?.Volumes"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Volumes: </abbr>
                                    {{ timeTableGeral[i]['R3'][0]?.Volumes }}</span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R3'][0]?.pecasCritica"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Peças Críticas:
                                    </abbr>
                                    <span class="pnCritica"
                                        *ngFor="let pecas of timeTableGeral[i]['R3'][0]?.pecasCritica">
                                        {{ pecas.PN }}</span>
                                </span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['R3'][0] && (timeTableGeral[i]['R3'][0].chegada || timeTableGeral[i]['R3'][0].ChegadaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Chegada: </abbr>
                                    {{ timeTableGeral[i]['R3'][0]?.chegada ? (timeTableGeral[i]['R3'][0]?.chegada |
                                    date : 'dd/MM/yyyy HH:mm' : '+00:00') :
                                    (timeTableGeral[i]['R3'][0]?.ChegadaSCANIA | date :
                                    'dd/MM/yyyy HH:mm') }}
                                </span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['R3'][0] && (timeTableGeral[i]['R3'][0].entrada || timeTableGeral[i]['R3'][0].EntradaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Entrada: </abbr>
                                    {{ timeTableGeral[i]['R3'][0]?.entrada ? (timeTableGeral[i]['R3'][0]?.entrada |
                                    date : 'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['R3'][0]?.EntradaSCANIA | date :
                                    'dd/MM/yyyy HH:mm') }}
                                </span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['R3'][0] && (timeTableGeral[i]['R3'][0].saida || timeTableGeral[i]['R3'][0].SaidaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Saida: </abbr>
                                    {{ timeTableGeral[i]['R3'][0]?.saida ? (timeTableGeral[i]['R3'][0]?.saida | date :
                                    'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['R3'][0]?.SaidaSCANIA | date :
                                    'dd/MM/yyyy HH:mm') }}
                                </span>
                            </div>
                        </td>
                        <td [ngClass]="timeTableGeral[i]['R3'][1]?.statusEntrega"
                            (click)="timeTableGeral[i]['R3'][1] ? editDialog(timeTableGeral[i]['R3'][1]) : editDialog2('R3')"
                            *ngIf="R3">
                            <div class="infos">
                                <div class="infos">
                                    <span *ngIf="timeTableGeral[i]['R3'][1]?.ID"><abbr
                                            style="color: #000000; font-size: 1.8vh; font-weight: bold;"> ID:
                                        </abbr>
                                        {{ timeTableGeral[i]['R3'][1]?.ID }} </span>
                                </div>
                                <span *ngIf="timeTableGeral[i]['R3'][1]?.created"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> Created:
                                    </abbr>
                                    {{ timeTableGeral[i]['R3'][1]?.created | date : 'dd/MM/yyyy HH:mm' }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R3'][1]?.lastUpdate"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Last Update.:
                                    </abbr>
                                    {{ timeTableGeral[i]['R3'][1]?.lastUpdate | date : 'dd/MM/yyyy HH:mm' }} by {{ timeTableGeral[i]['R3'][1]?.UpdateByUser }} </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['R3'][1]?.idContainer" class="infos">
                                <span *ngIf="timeTableGeral[i]['R3'][1]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container: </abbr>
                                    {{ timeTableGeral[i]['R3'][1]?.ID }}<br> </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['R3'][1]?.CTNRAlugado" class="infos">
                                <span *ngIf="timeTableGeral[i]['R3'][1]?.CTNRAlugado"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container Alugado:
                                    </abbr>
                                    {{ timeTableGeral[i]['R3'][1]?.CTNRAlugado }}<br> </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['R3'][1]?.viagem" class="infos">
                                <span *ngIf="timeTableGeral[i]['R3'][1]?.viagem"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Viagem:
                                    </abbr>
                                    {{ timeTableGeral[i]['R3'][1]?.viagem }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R3'][1]?.Transportadora"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Transp.: </abbr>
                                    {{ timeTableGeral[i]['R3'][1]?.Transportadora }}</span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R3'][1]?.Plate "> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Placa: </abbr>
                                    {{ timeTableGeral[i]['R3'][1]?.Plate }}<br> </span>
                            </div>
                            <div class="infos">
                                <span class="fornecedores" *ngIf="timeTableGeral[i]['R3'][1]?.Fornecedores"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Fornecedores:
                                    </abbr>
                                    {{ timeTableGeral[i]['R3'][1]?.Fornecedores }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R3'][1]?.Volumes"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Volumes:</abbr>
                                    {{ timeTableGeral[i]['R3'][1]?.Volumes }}</span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['R3'][1] && (timeTableGeral[i]['R3'][1].chegada || timeTableGeral[i]['R3'][1].ChegadaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Chegada: </abbr>
                                    {{ timeTableGeral[i]['R3'][1]?.chegada ? (timeTableGeral[i]['R3'][1]?.chegada |
                                    date : 'dd/MM/yyyy HH:mm' : '+00:00') :
                                    (timeTableGeral[i]['R3'][1]?.ChegadaSCANIA | date :
                                    'dd/MM/yyyy HH:mm') }}
                                </span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['R3'][1] && (timeTableGeral[i]['R3'][1].entrada || timeTableGeral[i]['R3'][1].EntradaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Entrada: </abbr>
                                    {{ timeTableGeral[i]['R3'][1]?.entrada ? (timeTableGeral[i]['R3'][1]?.entrada |
                                    date : 'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['R3'][1]?.EntradaSCANIA | date :
                                    'dd/MM/yyyy HH:mm') }}
                                </span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['R3'][1] && (timeTableGeral[i]['R3'][1].saida || timeTableGeral[i]['R3'][1].SaidaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Saida:</abbr>
                                    {{ timeTableGeral[i]['R3'][1]?.saida ? (timeTableGeral[i]['R3'][1]?.saida | date :
                                    'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['R16'][1]?.SaidaSCANIA | date :
                                    'dd/MM/yyyy HH:mm') }}
                                </span>
                            </div>
                        </td>

                        <!-- ************************************************************************************************************************* -->

                        <!-- <td [ngClass]="timeTableGeral[i]['R16'][3]?.statusEntrega"
                            (click)="timeTableGeral[i]['R16'][3] ? editDialog(timeTableGeral[i]['R16'][3]) : editDialog2('R16')"
                            *ngIf="R16">
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R16'][3]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> ID:
                                    </abbr>
                                    {{ timeTableGeral[i]['R16'][3]?.ID }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R16'][3]?.created"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> Created:
                                    </abbr>
                                    {{ timeTableGeral[i]['R16'][3]?.created | date : 'dd/MM/yyyy HH:mm' }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R16'][3]?.lastUpdate"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Last Update.:
                                    </abbr>
                                    {{ timeTableGeral[i]['R16'][3]?.lastUpdate | date : 'dd/MM/yyyy HH:mm' }}
                                </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['R16'][3]?.idContainer" class="infos">
                                <span *ngIf="timeTableGeral[i]['R16'][3]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container: </abbr>
                                    {{ timeTableGeral[i]['R16'][3]?.ID }}<br> </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['R16'][3]?.CTNRAlugado" class="infos">
                                <span *ngIf="timeTableGeral[i]['R16'][3]?.CTNRAlugado"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container Alugado:
                                    </abbr>
                                    {{ timeTableGeral[i]['R16'][3]?.CTNRAlugado }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R16'][3]?.Transportadora"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Transp.: </abbr>
                                    {{ timeTableGeral[i]['R16'][3]?.Transportadora }} <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R16'][3]?.Plate "> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Placa: </abbr>
                                    {{ timeTableGeral[i]['R16'][3]?.Plate }} <br></span>
                            </div>
                            <div class="infos">
                                <span class="fornecedores" *ngIf="timeTableGeral[i]['R16'][3]?.Fornecedores"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Fornecedores:
                                    </abbr>
                                    {{ timeTableGeral[i]['R16'][3]?.Fornecedores }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R16'][3]?.Volumes"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Volumes: </abbr>
                                    {{ timeTableGeral[i]['R16'][3]?.Volumes }} <br></span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['R16'][3] && (timeTableGeral[i]['R16'][3].chegada || timeTableGeral[i]['R16'][3].ChegadaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Chegada: </abbr>
                                    {{ timeTableGeral[i]['R16'][3]?.chegada ? (timeTableGeral[i]['R16'][3]?.chegada |
                                    date : 'dd/MM/yyyy HH:mm' : '+00:00') :
                                    (timeTableGeral[i]['R16'][3]?.ChegadaSCANIA | date :
                                    'dd/MM/yyyy HH:mm')}}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['R16'][3] && (timeTableGeral[i]['R16'][3].entrada || timeTableGeral[i]['R16'][3].EntradaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Entrada: </abbr>
                                    {{ timeTableGeral[i]['R16'][3]?.entrada ? (timeTableGeral[i]['R16'][3]?.entrada |
                                    date : 'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['R16'][3]?.EntradaSCANIA | date :
                                    'dd/MM/yyyy HH:mm')}}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['R16'][3] && (timeTableGeral[i]['R16'][3].saida || timeTableGeral[i]['R16'][3].SaidaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Saida: </abbr>
                                    {{ timeTableGeral[i]['R16'][3]?.saida ? (timeTableGeral[i]['R16'][3]?.saida | date :
                                    'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['R16'][3]?.SaidaSCANIA | date :
                                    'dd/MM/yyyy HH:mm')}}
                                </span>
                            </div>
                        </td> -->

                        <!-- ******************************************************************************* -->


                        <td [ngClass]="timeTableGeral[i]['R26'][0]?.statusEntrega"
                            (click)="timeTableGeral[i]['R26'][0] ? editDialog(timeTableGeral[i]['R26'][0]) : editDialog2('R26')"
                            *ngIf="R26">
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R26'][0]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> ID:
                                    </abbr>
                                    {{ timeTableGeral[i]['R26'][0]?.ID }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R26'][0]?.created"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> Created:
                                    </abbr>
                                    {{ timeTableGeral[i]['R26'][0]?.created | date : 'dd/MM/yyyy HH:mm' }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R26'][0]?.lastUpdate"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Last Update.:
                                    </abbr>
                                    {{ timeTableGeral[i]['R26'][0]?.lastUpdate | date : 'dd/MM/yyyy HH:mm' }} by {{ timeTableGeral[i]['R26'][0]?.UpdateByUser }} 
                                </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['R26'][0]?.viagem" class="infos">
                                <span *ngIf="timeTableGeral[i]['R26'][0]?.viagem"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Viagem: </abbr>
                                    {{ timeTableGeral[i]['R26'][0]?.viagem }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R26'][0]?.Transportadora"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Transp.: </abbr>
                                    {{ timeTableGeral[i]['R26'][0]?.Transportadora }} <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R26'][0]?.Plate "> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Placa: </abbr>
                                    {{ timeTableGeral[i]['R26'][0]?.Plate }} <br></span>
                            </div>
                            <div class="infos">
                                <span class="fornecedores" *ngIf="timeTableGeral[i]['R26'][0]?.Fornecedores"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Fornecedores:
                                    </abbr>
                                    {{ timeTableGeral[i]['R26'][0]?.Fornecedores }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R26'][0]?.Volumes"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Volumes: </abbr>
                                    {{ timeTableGeral[i]['R26'][0]?.Volumes }} <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R26'][0]?.pecasCritica"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Peças Críticas:
                                    </abbr>
                                    <span class="pnCritica"
                                        *ngFor="let pecas of timeTableGeral[i]['R26'][0]?.pecasCritica">
                                        {{ pecas.PN }}</span>
                                </span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['R26'][0] && (timeTableGeral[i]['R26'][0].chegada || timeTableGeral[i]['R26'][0].ChegadaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Chegada: </abbr>
                                    {{ timeTableGeral[i]['R26'][0]?.chegada ? (timeTableGeral[i]['R26'][0]?.chegada |
                                    date : 'dd/MM/yyyy HH:mm' : '+00:00') :
                                    (timeTableGeral[i]['R26'][0]?.ChegadaSCANIA | date :
                                    'dd/MM/yyyy HH:mm')}}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['R26'][0] && (timeTableGeral[i]['R26'][0].entrada || timeTableGeral[i]['R26'][0].EntradaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Entrada: </abbr>
                                    {{ timeTableGeral[i]['R26'][0]?.entrada ? (timeTableGeral[i]['R26'][0]?.entrada |
                                    date : 'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['R26'][0]?.EntradaSCANIA | date :
                                    'dd/MM/yyyy HH:mm')}}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['R26'][0] && (timeTableGeral[i]['R26'][0].saida || timeTableGeral[i]['R26'][0].SaidaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Saida: </abbr>
                                    {{ timeTableGeral[i]['R26'][0]?.saida ? (timeTableGeral[i]['R26'][0]?.saida | date :
                                    'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['R26'][0]?.SaidaSCANIA | date :
                                    'dd/MM/yyyy HH:mm')}}
                                </span>
                            </div>
                        </td>

                        <!-- ********************************************************************************************************************************** -->


                        <td [ngClass]="timeTableGeral[i]['R4'][0]?.statusEntrega"
                            (click)="timeTableGeral[i]['R4'][0] ? editDialog(timeTableGeral[i]['R4'][0]) : editDialog2('R4')"
                            *ngIf="R4">
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R4'][0]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> ID:
                                    </abbr>
                                    {{ timeTableGeral[i]['R4'][0]?.ID }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R4'][0]?.created"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> Created:
                                    </abbr>
                                    {{ timeTableGeral[i]['R4'][0]?.created | date : 'dd/MM/yyyy HH:mm' }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R4'][0]?.lastUpdate"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> Last Update.:
                                    </abbr>
                                    {{ timeTableGeral[i]['R4'][0]?.lastUpdate | date : 'dd/MM/yyyy HH:mm' }} by {{ timeTableGeral[i]['R4'][0]?.UpdateByUser }}  </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['R4'][0]?.idContainer" class="infos">
                                <span *ngIf="timeTableGeral[i]['R4'][0]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container: </abbr>
                                    {{ timeTableGeral[i]['R4'][0]?.ID }}<br> </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['R4'][0]?.CTNRAlugado" class="infos">
                                <span *ngIf="timeTableGeral[i]['R4'][0]?.CTNRAlugado"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container Alugado:
                                    </abbr>
                                    {{ timeTableGeral[i]['R4'][0]?.CTNRAlugado }}<br> </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['R4'][0]?.viagem" class="infos">
                                <span *ngIf="timeTableGeral[i]['R4'][0]?.viagem"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Viagem:
                                    </abbr>
                                    {{ timeTableGeral[i]['R4'][0]?.viagem }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R4'][0]?.Transportadora"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Transp.: </abbr>
                                    {{ timeTableGeral[i]['R4'][0]?.Transportadora }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R4'][0]?.Plate "><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> Placa: </abbr>
                                    {{ timeTableGeral[i]['R4'][0]?.Plate }}</span>
                            </div>
                            <div class="infos">
                                <span class="fornecedores" *ngIf="timeTableGeral[i]['R4'][0]?.Fornecedores"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Fornecedores:
                                    </abbr>
                                    {{ timeTableGeral[i]['R4'][0]?.Fornecedores }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R4'][0]?.Volumes"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Volumes: </abbr>
                                    {{ timeTableGeral[i]['R4'][0]?.Volumes }}</span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R4'][0]?.pecasCritica"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Peças Críticas:
                                    </abbr>
                                    <span class="pnCritica"
                                        *ngFor="let pecas of timeTableGeral[i]['R4'][0]?.pecasCritica">
                                        {{ pecas.PN }}</span>
                                </span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['R4'][0] && (timeTableGeral[i]['R4'][0].chegada || timeTableGeral[i]['R4'][0].ChegadaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Chegada: </abbr>
                                    {{ timeTableGeral[i]['R4'][0].chegada ? (timeTableGeral[i]['R4'][0]?.chegada |
                                    date : 'dd/MM/yyyy HH:mm' : '+00:00') :
                                    (timeTableGeral[i]['R4'][0]?.ChegadaSCANIA | date :
                                    'dd/MM/yyyy HH:mm') }}
                                </span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['R4'][0] && (timeTableGeral[i]['R4'][0].entrada || timeTableGeral[i]['R4'][0].EntradaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Entrada: </abbr>
                                    {{ timeTableGeral[i]['R4'][0].entrada ? (timeTableGeral[i]['R4'][0].entrada | date
                                    : 'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['R4'][0]?.EntradaSCANIA | date :
                                    'dd/MM/yyyy HH:mm') }}
                                </span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['R4'][0] && (timeTableGeral[i]['R4'][0].saida || timeTableGeral[i]['R4'][0].SaidaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Saida: </abbr>
                                    {{ timeTableGeral[i]['R4'][0].saida ? (timeTableGeral[i]['R4'][0].saida | date :
                                    'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['R4'][0]?.SaidaSCANIA | date :
                                    'dd/MM/yyyy HH:mm') }}
                                </span>
                            </div>
                        </td>

                        <!-- ******************************************************************************* -->


                        <td [ngClass]="timeTableGeral[i]['R40'][0]?.statusEntrega"
                            (click)="timeTableGeral[i]['R40'][0] ? editDialog(timeTableGeral[i]['R40'][0]) : editDialog2('R40')"
                            *ngIf="R40">
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R40'][0]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> ID:
                                    </abbr>
                                    {{ timeTableGeral[i]['R40'][0]?.ID }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R40'][0]?.created"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> Created:
                                    </abbr>
                                    {{ timeTableGeral[i]['R40'][0]?.created | date : 'dd/MM/yyyy HH:mm' }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R40'][0]?.lastUpdate"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Last Update.:
                                    </abbr>
                                    {{ timeTableGeral[i]['R40'][0]?.lastUpdate | date : 'dd/MM/yyyy HH:mm' }} by {{ timeTableGeral[i]['R40'][0]?.UpdateByUser }} </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['R40'][0]?.idContainer" class="infos">
                                <span *ngIf="timeTableGeral[i]['R40'][0]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container: </abbr>
                                    {{ timeTableGeral[i]['R40'][0]?.ID }}<br> </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['R40'][0]?.CTNRAlugado" class="infos">
                                <span *ngIf="timeTableGeral[i]['R40'][0]?.CTNRAlugado"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container Alugado:
                                    </abbr>
                                    {{ timeTableGeral[i]['R40'][0]?.CTNRAlugado }}<br> </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['R40'][0]?.viagem" class="infos">
                                <span *ngIf="timeTableGeral[i]['R40'][0]?.viagem"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Viagem:
                                    </abbr>
                                    {{ timeTableGeral[i]['R40'][0]?.viagem }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R40'][0]?.Transportadora"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Transp.: </abbr>
                                    {{ timeTableGeral[i]['R40'][0]?.Transportadora }}</span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R40'][0]?.Plate "><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Placa: </abbr>
                                    {{ timeTableGeral[i]['R40'][0]?.Plate }} </span>
                            </div>
                            <div class="infos">
                                <span class="fornecedores" *ngIf="timeTableGeral[i]['R40'][0]?.Fornecedores"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Fornecedores:
                                    </abbr>
                                    {{ timeTableGeral[i]['R40'][0]?.Fornecedores }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R40'][0]?.Volumes"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Volumes: </abbr>
                                    {{ timeTableGeral[i]['R40'][0]?.Volumes }}</span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R40'][0]?.pecasCritica"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Peças Críticas:
                                    </abbr>
                                    <span class="pnCritica"
                                        *ngFor="let pecas of timeTableGeral[i]['R40'][0]?.pecasCritica">
                                        {{ pecas.PN }}</span>
                                </span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['R40'][0] && (timeTableGeral[i]['R40'][0].chegada || timeTableGeral[i]['R40'][0].ChegadaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Chegada: </abbr>
                                    {{ timeTableGeral[i]['R40'][0]?.chegada ? (timeTableGeral[i]['R40'][0]?.chegada |
                                    date : 'dd/MM/yyyy HH:mm' : '+00:00') :
                                    (timeTableGeral[i]['R40'][0]?.ChegadaSCANIA | date :
                                    'dd/MM/yyyy HH:mm') }}
                                </span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['R40'][0] && (timeTableGeral[i]['R40'][0].entrada || timeTableGeral[i]['R40'][0].EntradaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Entrada: </abbr>
                                    {{ timeTableGeral[i]['R40'][0]?.entrada ? (timeTableGeral[i]['R40'][0]?.entrada |
                                    date : 'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['R40'][0]?.EntradaSCANIA | date :
                                    'dd/MM/yyyy HH:mm') }}
                                </span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['R40'][0] && (timeTableGeral[i]['R40'][0].saida || timeTableGeral[i]['R40'][0].SaidaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Saida: </abbr>
                                    {{ timeTableGeral[i]['R40'][0]?.saida ? (timeTableGeral[i]['R40'][0]?.saida | date :
                                    'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['R40'][0]?.SaidaSCANIA | date :
                                    'dd/MM/yyyy HH:mm') }}
                                </span>
                            </div>
                        </td>
                        <td [ngClass]="timeTableGeral[i]['R40'][1]?.statusEntrega"
                            (click)="timeTableGeral[i]['R40'][1] ? editDialog(timeTableGeral[i]['R40'][1]) : editDialog2('R40')"
                            *ngIf="R40">
                            <div class="infos">
                                <div class="infos">
                                    <span *ngIf="timeTableGeral[i]['R40'][1]?.ID"><abbr
                                            style="color: #000000; font-size: 1.8vh; font-weight: bold;"> ID:
                                        </abbr>
                                        {{ timeTableGeral[i]['R40'][1]?.ID }} </span>
                                </div>
                                <span *ngIf="timeTableGeral[i]['R40'][1]?.created"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> Created:
                                    </abbr>
                                    {{ timeTableGeral[i]['R40'][1]?.created | date : 'dd/MM/yyyy HH:mm' }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R40'][1]?.lastUpdate"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Last Update.:
                                    </abbr>
                                    {{ timeTableGeral[i]['R40'][1]?.lastUpdate | date : 'dd/MM/yyyy HH:mm' }} by {{ timeTableGeral[i]['R40'][1]?.UpdateByUser }} </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['R40'][1]?.idContainer" class="infos">
                                <span *ngIf="timeTableGeral[i]['R40'][1]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container: </abbr>
                                    {{ timeTableGeral[i]['R40'][1]?.ID }}<br> </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['R40'][1]?.CTNRAlugado" class="infos">
                                <span *ngIf="timeTableGeral[i]['R40'][1]?.CTNRAlugado"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container Alugado:
                                    </abbr>
                                    {{ timeTableGeral[i]['R40'][1]?.CTNRAlugado }}<br> </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['R40'][1]?.viagem" class="infos">
                                <span *ngIf="timeTableGeral[i]['R40'][1]?.viagem"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Viagem:
                                    </abbr>
                                    {{ timeTableGeral[i]['R40'][1]?.viagem }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R40'][1]?.Transportadora"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Transp.: </abbr>
                                    {{ timeTableGeral[i]['R40'][1]?.Transportadora }}</span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R40'][1]?.Plate "> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Placa: </abbr>
                                    {{ timeTableGeral[i]['R40'][1]?.Plate }}<br> </span>
                            </div>
                            <div class="infos">
                                <span class="fornecedores" *ngIf="timeTableGeral[i]['R40'][1]?.Fornecedores"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Fornecedores:
                                    </abbr>
                                    {{ timeTableGeral[i]['R40'][1]?.Fornecedores }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R40'][1]?.Volumes"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Volumes:</abbr>
                                    {{ timeTableGeral[i]['R40'][1]?.Volumes }}</span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R40'][1]?.pecasCritica"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Peças Críticas:
                                    </abbr>
                                    <span class="pnCritica"
                                        *ngFor="let pecas of timeTableGeral[i]['R40'][1]?.pecasCritica">
                                        {{ pecas.PN }}</span>
                                </span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['R40'][1] && (timeTableGeral[i]['R40'][1].chegada || timeTableGeral[i]['R40'][1].ChegadaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Chegada: </abbr>
                                    {{ timeTableGeral[i]['R40'][1]?.chegada ? (timeTableGeral[i]['R40'][1]?.chegada |
                                    date : 'dd/MM/yyyy HH:mm' : '+00:00') :
                                    (timeTableGeral[i]['R40'][1]?.ChegadaSCANIA | date :
                                    'dd/MM/yyyy HH:mm') }}
                                </span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['R40'][1] && (timeTableGeral[i]['R40'][1].entrada || timeTableGeral[i]['R40'][1].EntradaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Entrada: </abbr>
                                    {{ timeTableGeral[i]['R40'][1]?.entrada ? (timeTableGeral[i]['R40'][1]?.entrada |
                                    date : 'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['R40'][1]?.EntradaSCANIA | date :
                                    'dd/MM/yyyy HH:mm') }}
                                </span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['R40'][1] && (timeTableGeral[i]['R40'][1].saida || timeTableGeral[i]['R40'][1].SaidaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Saida:</abbr>
                                    {{ timeTableGeral[i]['R40'][1]?.saida ? (timeTableGeral[i]['R40'][1]?.saida | date :
                                    'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['R40'][1]?.SaidaSCANIA | date :
                                    'dd/MM/yyyy HH:mm') }}
                                </span>
                            </div>
                        </td>

                        <!-- ******************************************************************************* -->


                        <td [ngClass]="timeTableGeral[i]['R54'][0]?.statusEntrega"
                            (click)="timeTableGeral[i]['R54'][0] ? editDialog(timeTableGeral[i]['R54'][0]) : editDialog2('R54')"
                            *ngIf="R54">
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R54'][0]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> ID:
                                    </abbr>
                                    {{ timeTableGeral[i]['R54'][0]?.ID }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R54'][0]?.created"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> Created:
                                    </abbr>
                                    {{ timeTableGeral[i]['R54'][0]?.created | date : 'dd/MM/yyyy HH:mm' }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R54'][0]?.lastUpdate"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Last Update.:
                                    </abbr>
                                    {{ timeTableGeral[i]['R54'][0]?.lastUpdate | date : 'dd/MM/yyyy HH:mm' }} by {{ timeTableGeral[i]['R54'][0]?.UpdateByUser }} 
                                </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['R54'][0]?.idContainer" class="infos">
                                <span *ngIf="timeTableGeral[i]['R54'][0]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container: </abbr>
                                    {{ timeTableGeral[i]['R54'][0]?.ID }}<br> </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['R54'][0]?.CTNRAlugado" class="infos">
                                <span *ngIf="timeTableGeral[i]['R54'][0]?.CTNRAlugado"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container Alugado:
                                    </abbr>
                                    {{ timeTableGeral[i]['R54'][0]?.CTNRAlugado }}<br> </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['R54'][0]?.viagem" class="infos">
                                <span *ngIf="timeTableGeral[i]['R54'][0]?.viagem"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Viagem:
                                    </abbr>
                                    {{ timeTableGeral[i]['R54'][0]?.viagem }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R54'][0]?.Transportadora"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Transp.: </abbr>
                                    {{ timeTableGeral[i]['R54'][0]?.Transportadora }} <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R54'][0]?.Plate "> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Placa: </abbr>
                                    {{ timeTableGeral[i]['R54'][0]?.Plate }} <br></span>
                            </div>
                            <div class="infos">
                                <span class="fornecedores" *ngIf="timeTableGeral[i]['R54'][0]?.Fornecedores"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Fornecedores:
                                    </abbr>
                                    {{ timeTableGeral[i]['R54'][0]?.Fornecedores }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R54'][0]?.Volumes"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Volumes: </abbr>
                                    {{ timeTableGeral[i]['R54'][0]?.Volumes }} <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R54'][0]?.pecasCritica"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Peças Críticas:
                                    </abbr>
                                    <span class="pnCritica"
                                        *ngFor="let pecas of timeTableGeral[i]['R54'][0]?.pecasCritica">
                                        {{ pecas.PN }}</span>
                                </span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['R54'][0] && (timeTableGeral[i]['R54'][0].chegada || timeTableGeral[i]['R54'][0].ChegadaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Chegada: </abbr>
                                    {{ timeTableGeral[i]['R54'][0]?.chegada ? (timeTableGeral[i]['R54'][0]?.chegada |
                                    date : 'dd/MM/yyyy HH:mm' : '+00:00') :
                                    (timeTableGeral[i]['R54'][0]?.ChegadaSCANIA | date :
                                    'dd/MM/yyyy HH:mm')}}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['R54'][0] && (timeTableGeral[i]['R54'][0].entrada || timeTableGeral[i]['R54'][0].EntradaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Entrada: </abbr>
                                    {{ timeTableGeral[i]['R54'][0]?.entrada ? (timeTableGeral[i]['R54'][0]?.entrada |
                                    date : 'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['R54'][0]?.EntradaSCANIA | date :
                                    'dd/MM/yyyy HH:mm')}}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['R54'][0] && (timeTableGeral[i]['R54'][0].saida || timeTableGeral[i]['R54'][0].SaidaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Saida: </abbr>
                                    {{ timeTableGeral[i]['R54'][0]?.saida ? (timeTableGeral[i]['R54'][0]?.saida | date :
                                    'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['R54'][0]?.SaidaSCANIA | date :
                                    'dd/MM/yyyy HH:mm')}}
                                </span>
                            </div>
                        </td>
                        <td [ngClass]="timeTableGeral[i]['R54'][1]?.statusEntrega"
                            (click)="timeTableGeral[i]['R54'][1] ? editDialog(timeTableGeral[i]['R54'][1]) : editDialog2('R54')"
                            *ngIf="R54">
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R54'][1]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> ID:
                                    </abbr>
                                    {{ timeTableGeral[i]['R54'][1]?.ID }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R54'][1]?.created"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> Created:
                                    </abbr>
                                    {{ timeTableGeral[i]['R54'][1]?.created | date : 'dd/MM/yyyy HH:mm' }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R54'][1]?.lastUpdate"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Last Update.:
                                    </abbr>
                                    {{ timeTableGeral[i]['R54'][1]?.lastUpdate | date : 'dd/MM/yyyy HH:mm' }} by {{ timeTableGeral[i]['R54'][1]?.UpdateByUser }} 
                                </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['R54'][1]?.idContainer" class="infos">
                                <span *ngIf="timeTableGeral[i]['R54'][1]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container: </abbr>
                                    {{ timeTableGeral[i]['R54'][1]?.ID }}<br> </span>
                            </div>
                                                        <div *ngIf="timeTableGeral[i]['R54'][1]?.CTNRAlugado" class="infos">
                                <span *ngIf="timeTableGeral[i]['R54'][1]?.CTNRAlugado"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container Alugado:
                                    </abbr>
                                    {{ timeTableGeral[i]['R54'][1]?.CTNRAlugado }}<br> </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['R54'][1]?.viagem" class="infos">
                                <span *ngIf="timeTableGeral[i]['R54'][1]?.viagem"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Viagem:
                                    </abbr>
                                    {{ timeTableGeral[i]['R54'][1]?.viagem }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R54'][1]?.Transportadora"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Transp.: </abbr>
                                    {{ timeTableGeral[i]['R54'][1]?.Transportadora }} <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R54'][1]?.Plate "> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Placa: </abbr>
                                    {{ timeTableGeral[i]['R54'][1]?.Plate }} <br></span>
                            </div>
                            <div class="infos">
                                <span class="fornecedores" *ngIf="timeTableGeral[i]['R54'][1]?.Fornecedores"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Fornecedores:
                                    </abbr>
                                    {{ timeTableGeral[i]['R54'][1]?.Fornecedores }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R54'][1]?.Volumes"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Volumes: </abbr>
                                    {{ timeTableGeral[i]['R54'][1]?.Volumes }} <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R54'][1]?.pecasCritica"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Peças Críticas:
                                    </abbr>
                                    <span class="pnCritica"
                                        *ngFor="let pecas of timeTableGeral[i]['R54'][1]?.pecasCritica">
                                        {{ pecas.PN }}</span>
                                </span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['R54'][1] && (timeTableGeral[i]['R54'][1].chegada || timeTableGeral[i]['R54'][1].ChegadaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Chegada: </abbr>
                                    {{ timeTableGeral[i]['R54'][1]?.chegada ? (timeTableGeral[i]['R54'][1]?.chegada |
                                    date : 'dd/MM/yyyy HH:mm' : '+00:00') :
                                    (timeTableGeral[i]['R54'][1]?.ChegadaSCANIA | date :
                                    'dd/MM/yyyy HH:mm')}}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['R54'][1] && (timeTableGeral[i]['R54'][1].entrada || timeTableGeral[i]['R54'][1].EntradaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Entrada: </abbr>
                                    {{ timeTableGeral[i]['R54'][1]?.entrada ? (timeTableGeral[i]['R54'][1]?.entrada |
                                    date : 'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['R54'][1]?.EntradaSCANIA | date :
                                    'dd/MM/yyyy HH:mm')}}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['R54'][1] && (timeTableGeral[i]['R54'][1].saida || timeTableGeral[i]['R54'][1].SaidaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Saida: </abbr>
                                    {{ timeTableGeral[i]['R54'][1]?.saida ? (timeTableGeral[i]['R54'][1]?.saida | date :
                                    'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['R54'][1]?.SaidaSCANIA | date :
                                    'dd/MM/yyyy HH:mm')}}
                                </span>
                            </div>
                        </td>

                        <!-- ********************************************************************************************************************************** -->

                        <td [ngClass]="timeTableGeral[i]['E56'][0]?.statusEntrega"
                            (click)="timeTableGeral[i]['E56'][0] ? editDialog(timeTableGeral[i]['E56'][0]) : editDialog2('E56')"
                            *ngIf="E56">
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['E56'][0]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> ID:
                                    </abbr>
                                    {{ timeTableGeral[i]['E56'][0]?.ID }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['E56'][0]?.created"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> Created:
                                    </abbr>
                                    {{ timeTableGeral[i]['E56'][0]?.created | date : 'dd/MM/yyyy HH:mm' }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['E56'][0]?.lastUpdate"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Last Update.:
                                    </abbr>
                                    {{ timeTableGeral[i]['E56'][0]?.lastUpdate | date : 'dd/MM/yyyy HH:mm' }} by {{ timeTableGeral[i]['E56'][0]?.UpdateByUser }} 
                                </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['E56'][0]?.idContainer" class="infos">
                                <span *ngIf="timeTableGeral[i]['E56'][0]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container: </abbr>
                                    {{ timeTableGeral[i]['E56'][0]?.ID }}<br> </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['E56'][0]?.CTNRAlugado" class="infos">
                                <span *ngIf="timeTableGeral[i]['E56'][0]?.CTNRAlugado"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container Alugado:
                                    </abbr>
                                    {{ timeTableGeral[i]['E56'][0]?.CTNRAlugado }}<br> </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['E56'][0]?.viagem" class="infos">
                                <span *ngIf="timeTableGeral[i]['E56'][0]?.viagem"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Viagem:
                                    </abbr>
                                    {{ timeTableGeral[i]['E56'][0]?.viagem }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['E56'][0]?.Transportadora"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Transp.: </abbr>
                                    {{ timeTableGeral[i]['E56'][0]?.Transportadora }} <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['E56'][0]?.Plate "> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Placa: </abbr>
                                    {{ timeTableGeral[i]['E56'][0]?.Plate }} <br></span>
                            </div>
                            <div class="infos">
                                <span class="fornecedores" *ngIf="timeTableGeral[i]['E56'][0]?.Fornecedores"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Fornecedores:
                                    </abbr>
                                    {{ timeTableGeral[i]['E56'][0]?.Fornecedores }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['E56'][0]?.Volumes"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Volumes: </abbr>
                                    {{ timeTableGeral[i]['E56'][0]?.Volumes }} <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['E56'][0]?.pecasCritica"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Peças Críticas:
                                    </abbr>
                                    <span class="pnCritica"
                                        *ngFor="let pecas of timeTableGeral[i]['E56'][0]?.pecasCritica">
                                        {{ pecas.PN }}</span>
                                </span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['E56'][0] && (timeTableGeral[i]['E56'][0].chegada || timeTableGeral[i]['E56'][0].ChegadaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Chegada: </abbr>
                                    {{ timeTableGeral[i]['E56'][0]?.chegada ? (timeTableGeral[i]['E56'][0]?.chegada |
                                    date : 'dd/MM/yyyy HH:mm' : '+00:00') :
                                    (timeTableGeral[i]['E56'][0]?.ChegadaSCANIA | date :
                                    'dd/MM/yyyy HH:mm')}}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['E56'][0] && (timeTableGeral[i]['E56'][0].entrada || timeTableGeral[i]['E56'][0].EntradaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Entrada: </abbr>
                                    {{ timeTableGeral[i]['E56'][0]?.entrada ? (timeTableGeral[i]['E56'][0]?.entrada |
                                    date : 'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['E56'][0]?.EntradaSCANIA | date :
                                    'dd/MM/yyyy HH:mm')}}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['E56'][0] && (timeTableGeral[i]['E56'][0].saida || timeTableGeral[i]['E56'][0].SaidaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Saida: </abbr>
                                    {{ timeTableGeral[i]['E56'][0]?.saida ? (timeTableGeral[i]['E56'][0]?.saida | date :
                                    'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['E56'][0]?.SaidaSCANIA | date :
                                    'dd/MM/yyyy HH:mm')}}
                                </span>
                            </div>
                        </td>
                        <td [ngClass]="timeTableGeral[i]['E56'][1]?.statusEntrega"
                            (click)="timeTableGeral[i]['E56'][1] ? editDialog(timeTableGeral[i]['E56'][1]) : editDialog2('E56')"
                            *ngIf="E56">
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['E56'][1]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> ID:
                                    </abbr>
                                    {{ timeTableGeral[i]['E56'][1]?.ID }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['E56'][1]?.created"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> Created:
                                    </abbr>
                                    {{ timeTableGeral[i]['E56'][1]?.created | date : 'dd/MM/yyyy HH:mm' }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['E56'][1]?.lastUpdate"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Last Update.:
                                    </abbr>
                                    {{ timeTableGeral[i]['E56'][1]?.lastUpdate | date : 'dd/MM/yyyy HH:mm' }} by {{ timeTableGeral[i]['E56'][1]?.UpdateByUser }} 
                                </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['E56'][1]?.idContainer" class="infos">
                                <span *ngIf="timeTableGeral[i]['E56'][1]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container: </abbr>
                                    {{ timeTableGeral[i]['E56'][1]?.ID }}<br> </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['E56'][1]?.CTNRAlugado" class="infos">
                                <span *ngIf="timeTableGeral[i]['E56'][1]?.CTNRAlugado"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container Alugado:
                                    </abbr>
                                    {{ timeTableGeral[i]['E56'][1]?.CTNRAlugado }}<br> </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['E56'][1]?.viagem" class="infos">
                                <span *ngIf="timeTableGeral[i]['E56'][1]?.viagem"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Viagem:
                                    </abbr>
                                    {{ timeTableGeral[i]['E56'][1]?.viagem }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['E56'][1]?.Transportadora"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Transp.: </abbr>
                                    {{ timeTableGeral[i]['E56'][1]?.Transportadora }} <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['E56'][1]?.Plate "> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Placa: </abbr>
                                    {{ timeTableGeral[i]['E56'][1]?.Plate }} <br></span>
                            </div>
                            <div class="infos">
                                <span class="fornecedores" *ngIf="timeTableGeral[i]['E56'][1]?.Fornecedores"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Fornecedores:
                                    </abbr>
                                    {{ timeTableGeral[i]['E56'][1]?.Fornecedores }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['E56'][1]?.Volumes"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Volumes: </abbr>
                                    {{ timeTableGeral[i]['E56'][1]?.Volumes }} <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['E56'][1]?.pecasCritica"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Peças Críticas:
                                    </abbr>
                                    <span class="pnCritica"
                                        *ngFor="let pecas of timeTableGeral[i]['E56'][1]?.pecasCritica">
                                        {{ pecas.PN }}</span>
                                </span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['E56'][1] && (timeTableGeral[i]['E56'][1].chegada || timeTableGeral[i]['E56'][1].ChegadaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Chegada: </abbr>
                                    {{ timeTableGeral[i]['E56'][1]?.chegada ? (timeTableGeral[i]['E56'][1]?.chegada |
                                    date : 'dd/MM/yyyy HH:mm' : '+00:00') :
                                    (timeTableGeral[i]['E56'][1]?.ChegadaSCANIA | date :
                                    'dd/MM/yyyy HH:mm')}}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['E56'][1] && (timeTableGeral[i]['E56'][1].entrada || timeTableGeral[i]['E56'][1].EntradaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Entrada: </abbr>
                                    {{ timeTableGeral[i]['E56'][1]?.entrada ? (timeTableGeral[i]['E56'][1]?.entrada |
                                    date : 'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['E56'][1]?.EntradaSCANIA | date :
                                    'dd/MM/yyyy HH:mm')}}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['E56'][1] && (timeTableGeral[i]['E56'][1].saida || timeTableGeral[i]['E56'][1].SaidaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Saida: </abbr>
                                    {{ timeTableGeral[i]['E56'][1]?.saida ? (timeTableGeral[i]['E56'][1]?.saida | date :
                                    'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['E56'][1]?.SaidaSCANIA | date :
                                    'dd/MM/yyyy HH:mm')}}
                                </span>
                            </div>
                        </td>
                        <td [ngClass]="timeTableGeral[i]['E56'][2]?.statusEntrega"
                            (click)="timeTableGeral[i]['E56'][2] ? editDialog(timeTableGeral[i]['E56'][2]) : editDialog2('E56')"
                            *ngIf="E56">
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['E56'][2]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> ID:
                                    </abbr>
                                    {{ timeTableGeral[i]['E56'][2]?.ID }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['E56'][2]?.created"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> Created:
                                    </abbr>
                                    {{ timeTableGeral[i]['E56'][2]?.created | date : 'dd/MM/yyyy HH:mm' }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['E56'][2]?.lastUpdate"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Last Update.:
                                    </abbr>
                                    {{ timeTableGeral[i]['E56'][2]?.lastUpdate | date : 'dd/MM/yyyy HH:mm' }} by {{ timeTableGeral[i]['E56'][2]?.UpdateByUser }} 
                                </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['E56'][2]?.idContainer" class="infos">
                                <span *ngIf="timeTableGeral[i]['E56'][2]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container: </abbr>
                                    {{ timeTableGeral[i]['E56'][2]?.ID }}<br> </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['E56'][2]?.CTNRAlugado" class="infos">
                                <span *ngIf="timeTableGeral[i]['E56'][2]?.CTNRAlugado"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container Alugado:
                                    </abbr>
                                    {{ timeTableGeral[i]['E56'][2]?.CTNRAlugado }}<br> </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['E56'][2]?.viagem" class="infos">
                                <span *ngIf="timeTableGeral[i]['E56'][2]?.viagem"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Viagem:
                                    </abbr>
                                    {{ timeTableGeral[i]['E56'][2]?.viagem }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['E56'][2]?.Transportadora"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Transp.: </abbr>
                                    {{ timeTableGeral[i]['E56'][2]?.Transportadora }} <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['E56'][2]?.Plate "> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Placa: </abbr>
                                    {{ timeTableGeral[i]['E56'][2]?.Plate }} <br></span>
                            </div>
                            <div class="infos">
                                <span class="fornecedores" *ngIf="timeTableGeral[i]['E56'][2]?.Fornecedores"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Fornecedores:
                                    </abbr>
                                    {{ timeTableGeral[i]['E56'][2]?.Fornecedores }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['E56'][2]?.Volumes"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Volumes: </abbr>
                                    {{ timeTableGeral[i]['E56'][2]?.Volumes }} <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['E56'][2]?.pecasCritica"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Peças Críticas:
                                    </abbr>
                                    <span class="pnCritica"
                                        *ngFor="let pecas of timeTableGeral[i]['E56'][2]?.pecasCritica">
                                        {{ pecas.PN }}</span>
                                </span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['E56'][2] && (timeTableGeral[i]['E56'][2].chegada || timeTableGeral[i]['E56'][2].ChegadaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Chegada: </abbr>
                                    {{ timeTableGeral[i]['E56'][2]?.chegada ? (timeTableGeral[i]['E56'][2]?.chegada |
                                    date : 'dd/MM/yyyy HH:mm' : '+00:00') :
                                    (timeTableGeral[i]['E56'][2]?.ChegadaSCANIA | date :
                                    'dd/MM/yyyy HH:mm')}}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['E56'][2] && (timeTableGeral[i]['E56'][2].entrada || timeTableGeral[i]['E56'][2].EntradaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Entrada: </abbr>
                                    {{ timeTableGeral[i]['E56'][2]?.entrada ? (timeTableGeral[i]['E56'][2]?.entrada |
                                    date : 'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['E56'][2]?.EntradaSCANIA | date :
                                    'dd/MM/yyyy HH:mm')}}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['E56'][2] && (timeTableGeral[i]['E56'][2].saida || timeTableGeral[i]['E56'][2].SaidaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Saida: </abbr>
                                    {{ timeTableGeral[i]['E56'][2]?.saida ? (timeTableGeral[i]['E56'][2]?.saida | date :
                                    'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['E56'][2]?.SaidaSCANIA | date :
                                    'dd/MM/yyyy HH:mm')}}
                                </span>
                            </div>
                        </td>
                        <td [ngClass]="timeTableGeral[i]['E56'][3]?.statusEntrega"
                            (click)="timeTableGeral[i]['E56'][3] ? editDialog(timeTableGeral[i]['E56'][3]) : editDialog2('E56')"
                            *ngIf="E56">
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['E56'][3]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> ID:
                                    </abbr>
                                    {{ timeTableGeral[i]['E56'][3]?.ID }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['E56'][3]?.created"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> Created:
                                    </abbr>
                                    {{ timeTableGeral[i]['E56'][3]?.created | date : 'dd/MM/yyyy HH:mm' }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['E56'][3]?.lastUpdate"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Last Update.:
                                    </abbr>
                                    {{ timeTableGeral[i]['E56'][3]?.lastUpdate | date : 'dd/MM/yyyy HH:mm' }} by {{ timeTableGeral[i]['E56'][3]?.UpdateByUser }} 
                                </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['E56'][3]?.idContainer" class="infos">
                                <span *ngIf="timeTableGeral[i]['E56'][3]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container: </abbr>
                                    {{ timeTableGeral[i]['E56'][3]?.ID }}<br> </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['E56'][3]?.CTNRAlugado" class="infos">
                                <span *ngIf="timeTableGeral[i]['E56'][3]?.CTNRAlugado"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container Alugado:
                                    </abbr>
                                    {{ timeTableGeral[i]['E56'][3]?.CTNRAlugado }}<br> </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['E56'][3]?.viagem" class="infos">
                                <span *ngIf="timeTableGeral[i]['E56'][3]?.viagem"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Viagem:
                                    </abbr>
                                    {{ timeTableGeral[i]['E56'][3]?.viagem }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['E56'][3]?.Transportadora"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Transp.: </abbr>
                                    {{ timeTableGeral[i]['E56'][3]?.Transportadora }} <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['E56'][3]?.Plate "> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Placa: </abbr>
                                    {{ timeTableGeral[i]['E56'][3]?.Plate }} <br></span>
                            </div>
                            <div class="infos">
                                <span class="fornecedores" *ngIf="timeTableGeral[i]['E56'][3]?.Fornecedores"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Fornecedores:
                                    </abbr>
                                    {{ timeTableGeral[i]['E56'][3]?.Fornecedores }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['E56'][3]?.Volumes"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Volumes: </abbr>
                                    {{ timeTableGeral[i]['E56'][3]?.Volumes }} <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['E56'][3]?.pecasCritica"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Peças Críticas:
                                    </abbr>
                                    <span class="pnCritica"
                                        *ngFor="let pecas of timeTableGeral[i]['E56'][3]?.pecasCritica">
                                        {{ pecas.PN }}</span>
                                </span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['E56'][3] && (timeTableGeral[i]['E56'][3].chegada || timeTableGeral[i]['E56'][3].ChegadaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Chegada: </abbr>
                                    {{ timeTableGeral[i]['E56'][3]?.chegada ? (timeTableGeral[i]['E56'][3]?.chegada |
                                    date : 'dd/MM/yyyy HH:mm' : '+00:00') :
                                    (timeTableGeral[i]['E56'][3]?.ChegadaSCANIA | date :
                                    'dd/MM/yyyy HH:mm')}}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['E56'][3] && (timeTableGeral[i]['E56'][3].entrada || timeTableGeral[i]['E56'][3].EntradaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Entrada: </abbr>
                                    {{ timeTableGeral[i]['E56'][3]?.entrada ? (timeTableGeral[i]['E56'][3]?.entrada |
                                    date : 'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['E56'][3]?.EntradaSCANIA | date :
                                    'dd/MM/yyyy HH:mm')}}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['E56'][3] && (timeTableGeral[i]['E56'][3].saida || timeTableGeral[i]['E56'][3].SaidaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Saida: </abbr>
                                    {{ timeTableGeral[i]['E56'][3]?.saida ? (timeTableGeral[i]['E56'][3]?.saida | date :
                                    'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['E56'][3]?.SaidaSCANIA | date :
                                    'dd/MM/yyyy HH:mm')}}
                                </span>
                            </div>
                        </td>
                        <!-- ******************************************************************************* -->

                        <td [ngClass]="timeTableGeral[i]['E37'][0]?.statusEntrega"
                            (click)="timeTableGeral[i]['E37'][0] ? editDialog(timeTableGeral[i]['E37'][0]) : editDialog2('E37')"
                            *ngIf="E37">
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['E37'][0]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> ID:
                                    </abbr>
                                    {{ timeTableGeral[i]['E37'][0]?.ID }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['E37'][0]?.created"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> Created:
                                    </abbr>
                                    {{ timeTableGeral[i]['E37'][0]?.created | date : 'dd/MM/yyyy HH:mm' }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['E37'][0]?.lastUpdate"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Last Update.:
                                    </abbr>
                                    {{ timeTableGeral[i]['E37'][0]?.lastUpdate | date : 'dd/MM/yyyy HH:mm' }} by {{ timeTableGeral[i]['E37'][0]?.UpdateByUser }} 
                                </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['E37'][0]?.idContainer" class="infos">
                                <span *ngIf="timeTableGeral[i]['E37'][0]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container: </abbr>
                                    {{ timeTableGeral[i]['E37'][0]?.ID }}<br> </span>
                            </div>
                                                        <div *ngIf="timeTableGeral[i]['E37'][0]?.CTNRAlugado" class="infos">
                                <span *ngIf="timeTableGeral[i]['E37'][0]?.CTNRAlugado"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container Alugado:
                                    </abbr>
                                    {{ timeTableGeral[i]['E37'][0]?.CTNRAlugado }}<br> </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['R37'][0]?.viagem" class="infos">
                                <span *ngIf="timeTableGeral[i]['R37'][0]?.viagem"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Viagem:
                                    </abbr>
                                    {{ timeTableGeral[i]['R37'][0]?.viagem }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['E37'][0]?.Transportadora"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Transp.: </abbr>
                                    {{ timeTableGeral[i]['E37'][0]?.Transportadora }} <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['E37'][0]?.Plate "> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Placa: </abbr>
                                    {{ timeTableGeral[i]['E37'][0]?.Plate }} <br></span>
                            </div>
                            <div class="infos">
                                <span class="fornecedores" *ngIf="timeTableGeral[i]['E37'][0]?.Fornecedores"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Fornecedores:
                                    </abbr>
                                    {{ timeTableGeral[i]['E37'][0]?.Fornecedores }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['E37'][0]?.Volumes"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Volumes: </abbr>
                                    {{ timeTableGeral[i]['E37'][0]?.Volumes }} <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['E37'][0]?.pecasCritica"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Peças Críticas:
                                    </abbr>
                                    <span class="pnCritica"
                                        *ngFor="let pecas of timeTableGeral[i]['E37'][0]?.pecasCritica">
                                        {{ pecas.PN }}</span>
                                </span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['E37'][0] && (timeTableGeral[i]['E37'][0].chegada || timeTableGeral[i]['E37'][0].ChegadaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Chegada: </abbr>
                                    {{ timeTableGeral[i]['E37'][0]?.chegada ? (timeTableGeral[i]['E37'][0]?.chegada |
                                    date : 'dd/MM/yyyy HH:mm' : '+00:00') :
                                    (timeTableGeral[i]['E37'][0]?.ChegadaSCANIA | date :
                                    'dd/MM/yyyy HH:mm')}}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['E37'][0] && (timeTableGeral[i]['E37'][0].entrada || timeTableGeral[i]['E37'][0].EntradaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Entrada: </abbr>
                                    {{ timeTableGeral[i]['E37'][0]?.entrada ? (timeTableGeral[i]['E37'][0]?.entrada |
                                    date : 'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['E37'][0]?.EntradaSCANIA | date :
                                    'dd/MM/yyyy HH:mm')}}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['E37'][0] && (timeTableGeral[i]['E37'][0].saida || timeTableGeral[i]['E37'][0].SaidaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Saida: </abbr>
                                    {{ timeTableGeral[i]['E37'][0]?.saida ? (timeTableGeral[i]['E37'][0]?.saida | date :
                                    'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['E37'][0]?.SaidaSCANIA | date :
                                    'dd/MM/yyyy HH:mm')}}
                                </span>
                            </div>
                        </td>
                        <td [ngClass]="timeTableGeral[i]['E37'][1]?.statusEntrega"
                            (click)="timeTableGeral[i]['E37'][1] ? editDialog(timeTableGeral[i]['E37'][1]) : editDialog2('E37')"
                            *ngIf="E37">
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['E37'][1]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> ID:
                                    </abbr>
                                    {{ timeTableGeral[i]['E37'][1]?.ID }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['E37'][1]?.created"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> Created:
                                    </abbr>
                                    {{ timeTableGeral[i]['E37'][1]?.created | date : 'dd/MM/yyyy HH:mm' }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['E37'][1]?.lastUpdate"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Last Update.:
                                    </abbr>
                                    {{ timeTableGeral[i]['E37'][1]?.lastUpdate | date : 'dd/MM/yyyy HH:mm' }} by {{ timeTableGeral[i]['E37'][1]?.UpdateByUser }} 
                                </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['E37'][1]?.idContainer" class="infos">
                                <span *ngIf="timeTableGeral[i]['E37'][1]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container: </abbr>
                                    {{ timeTableGeral[i]['E37'][1]?.ID }}<br> </span>
                            </div>
                                                        <div *ngIf="timeTableGeral[i]['E37'][1]?.CTNRAlugado" class="infos">
                                <span *ngIf="timeTableGeral[i]['E37'][1]?.CTNRAlugado"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container Alugado:
                                    </abbr>
                                    {{ timeTableGeral[i]['E37'][1]?.CTNRAlugado }}<br> </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['R37'][1]?.viagem" class="infos">
                                <span *ngIf="timeTableGeral[i]['R37'][1]?.viagem"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Viagem:
                                    </abbr>
                                    {{ timeTableGeral[i]['R37'][1]?.viagem }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['E37'][1]?.Transportadora"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Transp.: </abbr>
                                    {{ timeTableGeral[i]['E37'][1]?.Transportadora }} <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['E37'][1]?.Plate "> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Placa: </abbr>
                                    {{ timeTableGeral[i]['E37'][1]?.Plate }} <br></span>
                            </div>
                            <div class="infos">
                                <span class="fornecedores" *ngIf="timeTableGeral[i]['E37'][1]?.Fornecedores"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Fornecedores:
                                    </abbr>
                                    {{ timeTableGeral[i]['E37'][1]?.Fornecedores }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['E37'][1]?.Volumes"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Volumes: </abbr>
                                    {{ timeTableGeral[i]['E37'][1]?.Volumes }} <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['E37'][1]?.pecasCritica"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Peças Críticas:
                                    </abbr>
                                    <span class="pnCritica"
                                        *ngFor="let pecas of timeTableGeral[i]['E37'][1]?.pecasCritica">
                                        {{ pecas.PN }}</span>
                                </span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['E37'][1] && (timeTableGeral[i]['E37'][1].chegada || timeTableGeral[i]['E37'][1].ChegadaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Chegada: </abbr>
                                    {{ timeTableGeral[i]['E37'][1]?.chegada ? (timeTableGeral[i]['E37'][1]?.chegada |
                                    date : 'dd/MM/yyyy HH:mm' : '+00:00') :
                                    (timeTableGeral[i]['E37'][1]?.ChegadaSCANIA | date :
                                    'dd/MM/yyyy HH:mm')}}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['E37'][1] && (timeTableGeral[i]['E37'][1].entrada || timeTableGeral[i]['E37'][1].EntradaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Entrada: </abbr>
                                    {{ timeTableGeral[i]['E37'][1]?.entrada ? (timeTableGeral[i]['E37'][1]?.entrada |
                                    date : 'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['E37'][1]?.EntradaSCANIA | date :
                                    'dd/MM/yyyy HH:mm')}}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['E37'][1] && (timeTableGeral[i]['E37'][1].saida || timeTableGeral[i]['E37'][1].SaidaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Saida: </abbr>
                                    {{ timeTableGeral[i]['E37'][1]?.saida ? (timeTableGeral[i]['E37'][1]?.saida | date :
                                    'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['E37'][1]?.SaidaSCANIA | date :
                                    'dd/MM/yyyy HH:mm')}}
                                </span>
                            </div>
                        </td>
                        <td [ngClass]="timeTableGeral[i]['E37'][2]?.statusEntrega"
                            (click)="timeTableGeral[i]['E37'][2] ? editDialog(timeTableGeral[i]['E37'][2]) : editDialog2('E37')"
                            *ngIf="E37">
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['E37'][2]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> ID:
                                    </abbr>
                                    {{ timeTableGeral[i]['E37'][2]?.ID }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['E37'][2]?.created"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> Created:
                                    </abbr>
                                    {{ timeTableGeral[i]['E37'][2]?.created | date : 'dd/MM/yyyy HH:mm' }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['E37'][2]?.lastUpdate"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Last Update.:
                                    </abbr>
                                    {{ timeTableGeral[i]['E37'][2]?.lastUpdate | date : 'dd/MM/yyyy HH:mm' }} by {{ timeTableGeral[i]['E37'][2]?.UpdateByUser }} 
                                </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['E37'][2]?.idContainer" class="infos">
                                <span *ngIf="timeTableGeral[i]['E37'][2]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container: </abbr>
                                    {{ timeTableGeral[i]['E37'][2]?.ID }}<br> </span>
                            </div>
                                                        <div *ngIf="timeTableGeral[i]['E37'][2]?.CTNRAlugado" class="infos">
                                <span *ngIf="timeTableGeral[i]['E37'][2]?.CTNRAlugado"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container Alugado:
                                    </abbr>
                                    {{ timeTableGeral[i]['E37'][2]?.CTNRAlugado }}<br> </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['R37'][2]?.viagem" class="infos">
                                <span *ngIf="timeTableGeral[i]['R37'][2]?.viagem"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Viagem:
                                    </abbr>
                                    {{ timeTableGeral[i]['R37'][2]?.viagem }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['E37'][2]?.Transportadora"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Transp.: </abbr>
                                    {{ timeTableGeral[i]['E37'][2]?.Transportadora }} <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['E37'][2]?.Plate "> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Placa: </abbr>
                                    {{ timeTableGeral[i]['E37'][2]?.Plate }} <br></span>
                            </div>
                            <div class="infos">
                                <span class="fornecedores" *ngIf="timeTableGeral[i]['E37'][2]?.Fornecedores"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Fornecedores:
                                    </abbr>
                                    {{ timeTableGeral[i]['E37'][2]?.Fornecedores }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['E37'][2]?.Volumes"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Volumes: </abbr>
                                    {{ timeTableGeral[i]['E37'][2]?.Volumes }} <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['E37'][2]?.pecasCritica"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Peças Críticas:
                                    </abbr>
                                    <span class="pnCritica"
                                        *ngFor="let pecas of timeTableGeral[i]['E37'][2]?.pecasCritica">
                                        {{ pecas.PN }}</span>
                                </span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['E37'][2] && (timeTableGeral[i]['E37'][2].chegada || timeTableGeral[i]['E37'][2].ChegadaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Chegada: </abbr>
                                    {{ timeTableGeral[i]['E37'][2]?.chegada ? (timeTableGeral[i]['E37'][2]?.chegada |
                                    date : 'dd/MM/yyyy HH:mm' : '+00:00') :
                                    (timeTableGeral[i]['E37'][2]?.ChegadaSCANIA | date :
                                    'dd/MM/yyyy HH:mm')}}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['E37'][2] && (timeTableGeral[i]['E37'][2].entrada || timeTableGeral[i]['E37'][2].EntradaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Entrada: </abbr>
                                    {{ timeTableGeral[i]['E37'][2]?.entrada ? (timeTableGeral[i]['E37'][2]?.entrada |
                                    date : 'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['E37'][2]?.EntradaSCANIA | date :
                                    'dd/MM/yyyy HH:mm')}}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['E37'][2] && (timeTableGeral[i]['E37'][2].saida || timeTableGeral[i]['E37'][2].SaidaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Saida: </abbr>
                                    {{ timeTableGeral[i]['E37'][2]?.saida ? (timeTableGeral[i]['E37'][2]?.saida | date :
                                    'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['E37'][2]?.SaidaSCANIA | date :
                                    'dd/MM/yyyy HH:mm')}}
                                </span>
                            </div>
                        </td>
                        <td [ngClass]="timeTableGeral[i]['E37'][3]?.statusEntrega"
                            (click)="timeTableGeral[i]['E37'][3] ? editDialog(timeTableGeral[i]['E37'][3]) : editDialog2('E37')"
                            *ngIf="E37">
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['E37'][3]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> ID:
                                    </abbr>
                                    {{ timeTableGeral[i]['E37'][3]?.ID }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['E37'][3]?.created"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> Created:
                                    </abbr>
                                    {{ timeTableGeral[i]['E37'][3]?.created | date : 'dd/MM/yyyy HH:mm' }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['E37'][3]?.lastUpdate"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Last Update.:
                                    </abbr>
                                    {{ timeTableGeral[i]['E37'][3]?.lastUpdate | date : 'dd/MM/yyyy HH:mm' }} by {{ timeTableGeral[i]['E37'][3]?.UpdateByUser }} 
                                </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['E37'][3]?.idContainer" class="infos">
                                <span *ngIf="timeTableGeral[i]['E37'][3]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container: </abbr>
                                    {{ timeTableGeral[i]['E37'][3]?.ID }}<br> </span>
                            </div>
                                                        <div *ngIf="timeTableGeral[i]['E37'][3]?.CTNRAlugado" class="infos">
                                <span *ngIf="timeTableGeral[i]['E37'][3]?.CTNRAlugado"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container Alugado:
                                    </abbr>
                                    {{ timeTableGeral[i]['E37'][3]?.CTNRAlugado }}<br> </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['R37'][3]?.viagem" class="infos">
                                <span *ngIf="timeTableGeral[i]['R37'][3]?.viagem"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Viagem:
                                    </abbr>
                                    {{ timeTableGeral[i]['R37'][3]?.viagem }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['E37'][3]?.Transportadora"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Transp.: </abbr>
                                    {{ timeTableGeral[i]['E37'][3]?.Transportadora }} <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['E37'][3]?.Plate "> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Placa: </abbr>
                                    {{ timeTableGeral[i]['E37'][3]?.Plate }} <br></span>
                            </div>
                            <div class="infos">
                                <span class="fornecedores" *ngIf="timeTableGeral[i]['E37'][3]?.Fornecedores"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Fornecedores:
                                    </abbr>
                                    {{ timeTableGeral[i]['E37'][3]?.Fornecedores }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['E37'][3]?.Volumes"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Volumes: </abbr>
                                    {{ timeTableGeral[i]['E37'][3]?.Volumes }} <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['E37'][3]?.pecasCritica"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Peças Críticas:
                                    </abbr>
                                    <span class="pnCritica"
                                        *ngFor="let pecas of timeTableGeral[i]['E37'][3]?.pecasCritica">
                                        {{ pecas.PN }}</span>
                                </span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['E37'][3] && (timeTableGeral[i]['E37'][3].chegada || timeTableGeral[i]['E37'][3].ChegadaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Chegada: </abbr>
                                    {{ timeTableGeral[i]['E37'][3]?.chegada ? (timeTableGeral[i]['E37'][3]?.chegada |
                                    date : 'dd/MM/yyyy HH:mm' : '+00:00') :
                                    (timeTableGeral[i]['E37'][3]?.ChegadaSCANIA | date :
                                    'dd/MM/yyyy HH:mm')}}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['E37'][3] && (timeTableGeral[i]['E37'][3].entrada || timeTableGeral[i]['E37'][3].EntradaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Entrada: </abbr>
                                    {{ timeTableGeral[i]['E37'][3]?.entrada ? (timeTableGeral[i]['E37'][3]?.entrada |
                                    date : 'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['E37'][3]?.EntradaSCANIA | date :
                                    'dd/MM/yyyy HH:mm')}}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['E37'][3] && (timeTableGeral[i]['E37'][3].saida || timeTableGeral[i]['E37'][3].SaidaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Saida: </abbr>
                                    {{ timeTableGeral[i]['E37'][3]?.saida ? (timeTableGeral[i]['E37'][3]?.saida | date :
                                    'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['E37'][3]?.SaidaSCANIA | date :
                                    'dd/MM/yyyy HH:mm')}}
                                </span>
                            </div>
                        </td>

                        <!-- ******************************************************************************* -->

                        <td [ngClass]="timeTableGeral[i]['R56'][0]?.statusEntrega"
                            (click)="timeTableGeral[i]['R56'][0] ? editDialog(timeTableGeral[i]['R56'][0]) : editDialog2('R56')"
                            *ngIf="R56">
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R56'][0]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> ID:
                                    </abbr>
                                    {{ timeTableGeral[i]['R56'][0]?.ID }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R56'][0]?.created"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> Created:
                                    </abbr>
                                    {{ timeTableGeral[i]['R56'][0]?.created | date : 'dd/MM/yyyy HH:mm' }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R56'][0]?.lastUpdate"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Last Update.:
                                    </abbr>
                                    {{ timeTableGeral[i]['R56'][0]?.lastUpdate | date : 'dd/MM/yyyy HH:mm' }} by {{ timeTableGeral[i]['R56'][0]?.UpdateByUser }} 
                                </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['R56'][0]?.idContainer" class="infos">
                                <span *ngIf="timeTableGeral[i]['R56'][0]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container: </abbr>
                                    {{ timeTableGeral[i]['R56'][0]?.ID }}<br> </span>
                            </div>
                                                        <div *ngIf="timeTableGeral[i]['R56'][0]?.CTNRAlugado" class="infos">
                                <span *ngIf="timeTableGeral[i]['R56'][0]?.CTNRAlugado"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container Alugado:
                                    </abbr>
                                    {{ timeTableGeral[i]['R56'][0]?.CTNRAlugado }}<br> </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['R56'][0]?.viagem" class="infos">
                                <span *ngIf="timeTableGeral[i]['R56'][0]?.viagem"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Viagem:
                                    </abbr>
                                    {{ timeTableGeral[i]['R56'][0]?.viagem }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R56'][0]?.Transportadora"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Transp.: </abbr>
                                    {{ timeTableGeral[i]['R56'][0]?.Transportadora }} <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R56'][0]?.Plate "> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Placa: </abbr>
                                    {{ timeTableGeral[i]['R56'][0]?.Plate }} <br></span>
                            </div>
                            <div class="infos">
                                <span class="fornecedores" *ngIf="timeTableGeral[i]['R56'][0]?.Fornecedores"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Fornecedores:
                                    </abbr>
                                    {{ timeTableGeral[i]['R56'][0]?.Fornecedores }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R56'][0]?.Volumes"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Volumes: </abbr>
                                    {{ timeTableGeral[i]['R56'][0]?.Volumes }} <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R56'][0]?.pecasCritica"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Peças Críticas:
                                    </abbr>
                                    <span class="pnCritica"
                                        *ngFor="let pecas of timeTableGeral[i]['R56'][0]?.pecasCritica">
                                        {{ pecas.PN }}</span>
                                </span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['R56'][0] && (timeTableGeral[i]['R56'][0].chegada || timeTableGeral[i]['R56'][0].ChegadaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Chegada: </abbr>
                                    {{ timeTableGeral[i]['R56'][0]?.chegada ? (timeTableGeral[i]['R56'][0]?.chegada |
                                    date : 'dd/MM/yyyy HH:mm' : '+00:00') :
                                    (timeTableGeral[i]['R56'][0]?.ChegadaSCANIA | date :
                                    'dd/MM/yyyy HH:mm')}}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['R56'][0] && (timeTableGeral[i]['R56'][0].entrada || timeTableGeral[i]['R56'][0].EntradaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Entrada: </abbr>
                                    {{ timeTableGeral[i]['R56'][0]?.entrada ? (timeTableGeral[i]['R56'][0]?.entrada |
                                    date : 'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['R56'][0]?.EntradaSCANIA | date :
                                    'dd/MM/yyyy HH:mm')}}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['R56'][0] && (timeTableGeral[i]['R56'][0].saida || timeTableGeral[i]['R56'][0].SaidaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Saida: </abbr>
                                    {{ timeTableGeral[i]['R56'][0]?.saida ? (timeTableGeral[i]['R56'][0]?.saida | date :
                                    'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['R56'][0]?.SaidaSCANIA | date :
                                    'dd/MM/yyyy HH:mm')}}
                                </span>
                            </div>
                        </td>
                        <td [ngClass]="timeTableGeral[i]['R56'][1]?.statusEntrega"
                            (click)="timeTableGeral[i]['R56'][1] ? editDialog(timeTableGeral[i]['R56'][1]) : editDialog2('R56')"
                            *ngIf="R56">
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R56'][1]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> ID:
                                    </abbr>
                                    {{ timeTableGeral[i]['R56'][1]?.ID }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R56'][1]?.created"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> Created:
                                    </abbr>
                                    {{ timeTableGeral[i]['R56'][1]?.created | date : 'dd/MM/yyyy HH:mm' }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R56'][1]?.lastUpdate"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Last Update.:
                                    </abbr>
                                    {{ timeTableGeral[i]['R56'][1]?.lastUpdate | date : 'dd/MM/yyyy HH:mm' }} by {{ timeTableGeral[i]['R56'][1]?.UpdateByUser }} 
                                </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['R56'][1]?.idContainer" class="infos">
                                <span *ngIf="timeTableGeral[i]['R56'][1]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container: </abbr>
                                    {{ timeTableGeral[i]['R56'][1]?.ID }}<br> </span>
                            </div>
                                                        <div *ngIf="timeTableGeral[i]['R56'][1]?.CTNRAlugado" class="infos">
                                <span *ngIf="timeTableGeral[i]['R56'][1]?.CTNRAlugado"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container Alugado:
                                    </abbr>
                                    {{ timeTableGeral[i]['R56'][1]?.CTNRAlugado }}<br> </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['R56'][1]?.viagem" class="infos">
                                <span *ngIf="timeTableGeral[i]['R56'][1]?.viagem"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Viagem:
                                    </abbr>
                                    {{ timeTableGeral[i]['R56'][1]?.viagem }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R56'][1]?.Transportadora"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Transp.: </abbr>
                                    {{ timeTableGeral[i]['R56'][1]?.Transportadora }} <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R56'][1]?.Plate "> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Placa: </abbr>
                                    {{ timeTableGeral[i]['R56'][1]?.Plate }} <br></span>
                            </div>
                            <div class="infos">
                                <span class="fornecedores" *ngIf="timeTableGeral[i]['R56'][1]?.Fornecedores"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Fornecedores:
                                    </abbr>
                                    {{ timeTableGeral[i]['R56'][1]?.Fornecedores }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R56'][1]?.Volumes"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Volumes: </abbr>
                                    {{ timeTableGeral[i]['R56'][1]?.Volumes }} <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R56'][1]?.pecasCritica"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Peças Críticas:
                                    </abbr>
                                    <span class="pnCritica"
                                        *ngFor="let pecas of timeTableGeral[i]['R56'][1]?.pecasCritica">
                                        {{ pecas.PN }}</span>
                                </span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['R56'][1] && (timeTableGeral[i]['R56'][1].chegada || timeTableGeral[i]['R56'][1].ChegadaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Chegada: </abbr>
                                    {{ timeTableGeral[i]['R56'][1]?.chegada ? (timeTableGeral[i]['R56'][1]?.chegada |
                                    date : 'dd/MM/yyyy HH:mm' : '+00:00') :
                                    (timeTableGeral[i]['R56'][1]?.ChegadaSCANIA | date :
                                    'dd/MM/yyyy HH:mm')}}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['R56'][1] && (timeTableGeral[i]['R56'][1].entrada || timeTableGeral[i]['R56'][1].EntradaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Entrada: </abbr>
                                    {{ timeTableGeral[i]['R56'][1]?.entrada ? (timeTableGeral[i]['R56'][1]?.entrada |
                                    date : 'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['R56'][1]?.EntradaSCANIA | date :
                                    'dd/MM/yyyy HH:mm')}}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['R56'][1] && (timeTableGeral[i]['R56'][1].saida || timeTableGeral[i]['R56'][1].SaidaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Saida: </abbr>
                                    {{ timeTableGeral[i]['R56'][1]?.saida ? (timeTableGeral[i]['R56'][1]?.saida | date :
                                    'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['R56'][1]?.SaidaSCANIA | date :
                                    'dd/MM/yyyy HH:mm')}}
                                </span>
                            </div>
                        </td>

                        <!-- ******************************************************************************* -->

                        <td [ngClass]="timeTableGeral[i]['R43'][0]?.statusEntrega"
                            (click)="timeTableGeral[i]['R43'][0] ? editDialog(timeTableGeral[i]['R43'][0]) : editDialog2('R43')"
                            *ngIf="R43">
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R43'][0]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> ID:
                                    </abbr>
                                    {{ timeTableGeral[i]['R43'][0]?.ID }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R43'][0]?.created"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> Created:
                                    </abbr>
                                    {{ timeTableGeral[i]['R43'][0]?.created | date : 'dd/MM/yyyy HH:mm' }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R43'][0]?.lastUpdate"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Last Update.:
                                    </abbr>
                                    {{ timeTableGeral[i]['R43'][0]?.lastUpdate | date : 'dd/MM/yyyy HH:mm' }} by {{ timeTableGeral[i]['R43'][0]?.UpdateByUser }} 
                                </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['R43'][0]?.idContainer" class="infos">
                                <span *ngIf="timeTableGeral[i]['R43'][0]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container: </abbr>
                                    {{ timeTableGeral[i]['R43'][0]?.ID }}<br> </span>
                            </div>
                                                        <div *ngIf="timeTableGeral[i]['R43'][0]?.CTNRAlugado" class="infos">
                                <span *ngIf="timeTableGeral[i]['R43'][0]?.CTNRAlugado"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container Alugado:
                                    </abbr>
                                    {{ timeTableGeral[i]['R43'][0]?.CTNRAlugado }}<br> </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['R43'][0]?.viagem" class="infos">
                                <span *ngIf="timeTableGeral[i]['R43'][0]?.viagem"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Viagem:
                                    </abbr>
                                    {{ timeTableGeral[i]['R43'][0]?.viagem }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R43'][0]?.Transportadora"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Transp.: </abbr>
                                    {{ timeTableGeral[i]['R43'][0]?.Transportadora }} <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R43'][0]?.Plate "> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Placa: </abbr>
                                    {{ timeTableGeral[i]['R43'][0]?.Plate }} <br></span>
                            </div>
                            <div class="infos">
                                <span class="fornecedores" *ngIf="timeTableGeral[i]['R43'][0]?.Fornecedores"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Fornecedores:
                                    </abbr>
                                    {{ timeTableGeral[i]['R43'][0]?.Fornecedores }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R43'][0]?.Volumes"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Volumes: </abbr>
                                    {{ timeTableGeral[i]['R43'][0]?.Volumes }} <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R43'][0]?.pecasCritica"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Peças Críticas:
                                    </abbr>
                                    <span class="pnCritica"
                                        *ngFor="let pecas of timeTableGeral[i]['R43'][0]?.pecasCritica">
                                        {{ pecas.PN }}</span>
                                </span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['R43'][0] && (timeTableGeral[i]['R43'][0].chegada || timeTableGeral[i]['R43'][0].ChegadaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Chegada: </abbr>
                                    {{ timeTableGeral[i]['R43'][0]?.chegada ? (timeTableGeral[i]['R43'][0]?.chegada |
                                    date : 'dd/MM/yyyy HH:mm' : '+00:00') :
                                    (timeTableGeral[i]['R43'][0]?.ChegadaSCANIA | date :
                                    'dd/MM/yyyy HH:mm')}}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['R43'][0] && (timeTableGeral[i]['R43'][0].entrada || timeTableGeral[i]['R43'][0].EntradaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Entrada: </abbr>
                                    {{ timeTableGeral[i]['R43'][0]?.entrada ? (timeTableGeral[i]['R43'][0]?.entrada |
                                    date : 'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['R43'][0]?.EntradaSCANIA | date :
                                    'dd/MM/yyyy HH:mm')}}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['R43'][0] && (timeTableGeral[i]['R43'][0].saida || timeTableGeral[i]['R43'][0].SaidaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Saida: </abbr>
                                    {{ timeTableGeral[i]['R43'][0]?.saida ? (timeTableGeral[i]['R43'][0]?.saida | date :
                                    'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['R43'][0]?.SaidaSCANIA | date :
                                    'dd/MM/yyyy HH:mm')}}
                                </span>
                            </div>
                        </td>


                        <!-- ******************************************************************************* -->

                        <td [ngClass]="timeTableGeral[i]['R22'][0]?.statusEntrega"
                            (click)="timeTableGeral[i]['R22'][0] ? editDialog(timeTableGeral[i]['R22'][0]) : editDialog2('R22')"
                            *ngIf="R22">
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R22'][0]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> ID:
                                    </abbr>
                                    {{ timeTableGeral[i]['R22'][0]?.ID }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R22'][0]?.created"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> Created:
                                    </abbr>
                                    {{ timeTableGeral[i]['R22'][0]?.created | date : 'dd/MM/yyyy HH:mm' }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R22'][0]?.lastUpdate"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Last Update.:
                                    </abbr>
                                    {{ timeTableGeral[i]['R22'][0]?.lastUpdate | date : 'dd/MM/yyyy HH:mm' }} by {{ timeTableGeral[i]['R22'][0]?.UpdateByUser }} 
                                </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['R22'][0]?.idContainer" class="infos">
                                <span *ngIf="timeTableGeral[i]['R22'][0]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container: </abbr>
                                    {{ timeTableGeral[i]['R22'][0]?.ID }}<br> </span>
                            </div>
                                                        <div *ngIf="timeTableGeral[i]['R22'][0]?.CTNRAlugado" class="infos">
                                <span *ngIf="timeTableGeral[i]['R22'][0]?.CTNRAlugado"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container Alugado:
                                    </abbr>
                                    {{ timeTableGeral[i]['R22'][0]?.CTNRAlugado }}<br> </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['R22'][0]?.viagem" class="infos">
                                <span *ngIf="timeTableGeral[i]['R22'][0]?.viagem"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Viagem:
                                    </abbr>
                                    {{ timeTableGeral[i]['R22'][0]?.viagem }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R22'][0]?.Transportadora"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Transp.: </abbr>
                                    {{ timeTableGeral[i]['R22'][0]?.Transportadora }} <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R22'][0]?.Plate "> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Placa: </abbr>
                                    {{ timeTableGeral[i]['R22'][0]?.Plate }} <br></span>
                            </div>
                            <div class="infos">
                                <span class="fornecedores" *ngIf="timeTableGeral[i]['R22'][0]?.Fornecedores"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Fornecedores:
                                    </abbr>
                                    {{ timeTableGeral[i]['R22'][0]?.Fornecedores }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R22'][0]?.Volumes"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Volumes: </abbr>
                                    {{ timeTableGeral[i]['R22'][0]?.Volumes }} <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R22'][0]?.pecasCritica"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Peças Críticas:
                                    </abbr>
                                    <span class="pnCritica"
                                        *ngFor="let pecas of timeTableGeral[i]['R22'][0]?.pecasCritica">
                                        {{ pecas.PN }}</span>
                                </span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['R22'][0] && (timeTableGeral[i]['R22'][0].chegada || timeTableGeral[i]['R22'][0].ChegadaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Chegada: </abbr>
                                    {{ timeTableGeral[i]['R22'][0]?.chegada ? (timeTableGeral[i]['R22'][0]?.chegada |
                                    date : 'dd/MM/yyyy HH:mm' : '+00:00') :
                                    (timeTableGeral[i]['R22'][0]?.ChegadaSCANIA | date :
                                    'dd/MM/yyyy HH:mm')}}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['R22'][0] && (timeTableGeral[i]['R22'][0].entrada || timeTableGeral[i]['R22'][0].EntradaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Entrada: </abbr>
                                    {{ timeTableGeral[i]['R22'][0]?.entrada ? (timeTableGeral[i]['R22'][0]?.entrada |
                                    date : 'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['R22'][0]?.EntradaSCANIA | date :
                                    'dd/MM/yyyy HH:mm')}}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['R22'][0] && (timeTableGeral[i]['R22'][0].saida || timeTableGeral[i]['R22'][0].SaidaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Saida: </abbr>
                                    {{ timeTableGeral[i]['R22'][0]?.saida ? (timeTableGeral[i]['R22'][0]?.saida | date :
                                    'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['R22'][0]?.SaidaSCANIA | date :
                                    'dd/MM/yyyy HH:mm')}}
                                </span>
                            </div>
                        </td>
                        <td [ngClass]="timeTableGeral[i]['R22'][1]?.statusEntrega"
                            (click)="timeTableGeral[i]['R22'][1] ? editDialog(timeTableGeral[i]['R22'][1]) : editDialog2('R22')"
                            *ngIf="R22">
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R22'][1]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> ID:
                                    </abbr>
                                    {{ timeTableGeral[i]['R22'][1]?.ID }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R22'][1]?.created"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;"> Created:
                                    </abbr>
                                    {{ timeTableGeral[i]['R22'][1]?.created | date : 'dd/MM/yyyy HH:mm' }} </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R22'][1]?.lastUpdate"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Last Update.:
                                    </abbr>
                                    {{ timeTableGeral[i]['R22'][1]?.lastUpdate | date : 'dd/MM/yyyy HH:mm' }} by {{ timeTableGeral[i]['R22'][1]?.UpdateByUser }} 
                                </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['R22'][1]?.idContainer" class="infos">
                                <span *ngIf="timeTableGeral[i]['R22'][1]?.ID"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container: </abbr>
                                    {{ timeTableGeral[i]['R22'][1]?.ID }}<br> </span>
                            </div>
                                                        <div *ngIf="timeTableGeral[i]['R22'][1]?.CTNRAlugado" class="infos">
                                <span *ngIf="timeTableGeral[i]['R22'][1]?.CTNRAlugado"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container Alugado:
                                    </abbr>
                                    {{ timeTableGeral[i]['R22'][1]?.CTNRAlugado }}<br> </span>
                            </div>
                            <div *ngIf="timeTableGeral[i]['R22'][1]?.viagem" class="infos">
                                <span *ngIf="timeTableGeral[i]['R22'][1]?.viagem"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Viagem:
                                    </abbr>
                                    {{ timeTableGeral[i]['R22'][1]?.viagem }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R22'][1]?.Transportadora"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Transp.: </abbr>
                                    {{ timeTableGeral[i]['R22'][1]?.Transportadora }} <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R22'][1]?.Plate "> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Placa: </abbr>
                                    {{ timeTableGeral[i]['R22'][1]?.Plate }} <br></span>
                            </div>
                            <div class="infos">
                                <span class="fornecedores" *ngIf="timeTableGeral[i]['R22'][1]?.Fornecedores"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Fornecedores:
                                    </abbr>
                                    {{ timeTableGeral[i]['R22'][1]?.Fornecedores }}<br> </span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R22'][1]?.Volumes"> <abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Volumes: </abbr>
                                    {{ timeTableGeral[i]['R22'][1]?.Volumes }} <br></span>
                            </div>
                            <div class="infos">
                                <span *ngIf="timeTableGeral[i]['R22'][1]?.pecasCritica"><abbr
                                        style="color: #000000; font-size: 1.8vh; font-weight: bold;">Peças Críticas:
                                    </abbr>
                                    <span class="pnCritica"
                                        *ngFor="let pecas of timeTableGeral[i]['R22'][1]?.pecasCritica">
                                        {{ pecas.PN }}</span>
                                </span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['R22'][1] && (timeTableGeral[i]['R22'][1].chegada || timeTableGeral[i]['R22'][1].ChegadaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Chegada: </abbr>
                                    {{ timeTableGeral[i]['R22'][1]?.chegada ? (timeTableGeral[i]['R22'][1]?.chegada |
                                    date : 'dd/MM/yyyy HH:mm' : '+00:00') :
                                    (timeTableGeral[i]['R22'][1]?.ChegadaSCANIA | date :
                                    'dd/MM/yyyy HH:mm')}}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['R22'][1] && (timeTableGeral[i]['R22'][1].entrada || timeTableGeral[i]['R22'][1].EntradaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Entrada: </abbr>
                                    {{ timeTableGeral[i]['R22'][1]?.entrada ? (timeTableGeral[i]['R22'][1]?.entrada |
                                    date : 'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['R22'][1]?.EntradaSCANIA | date :
                                    'dd/MM/yyyy HH:mm')}}
                                    <br></span>
                            </div>
                            <div class="infos">
                                <span
                                    *ngIf="timeTableGeral[i]['R22'][1] && (timeTableGeral[i]['R22'][1].saida || timeTableGeral[i]['R22'][1].SaidaSCANIA)">
                                    <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Saida: </abbr>
                                    {{ timeTableGeral[i]['R22'][1]?.saida ? (timeTableGeral[i]['R22'][1]?.saida | date :
                                    'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['R22'][1]?.SaidaSCANIA | date :
                                    'dd/MM/yyyy HH:mm')}}
                                </span>
                            </div>
                        </td>

                        <!-- ******************************************************************************* -->
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</body>

<body>
    <div class="container">
        <table class="table-selects">
            <thead>
                <tr>
                    <th class="flex">
                        <h1>VEICULOS EXCEDENTES</h1>
                    </th>
                </tr>
            </thead>
        </table>
    </div>
    <div class="table-container scrollable-container">
        <table>
            <thead class="sticky-header">
                <tr>
                    <th class="titulo-coluna" colspan="2">
                        <span class="semFundo">Veículo</span>
                    </th>
                    <th class="titulo-coluna" colspan="2">
                        <span class="semFundo">Volumes</span>
                    </th>
                    <th class="titulo-coluna" colspan="2">
                        <span class="semFundo">Area</span>
                    </th>
                    <th class="titulo-coluna" colspan="2">
                        <span class="semFundo">Janelas</span>
                    </th>
                    <th class="titulo-coluna" colspan="2">
                        <span class="semFundo">Transportadora</span>
                    </th>
                    <th class="titulo-coluna" colspan="2">
                        <span class="semFundo">Fornecedor</span>
                    </th>
                    <th class="titulo-coluna" colspan="2">
                        <span class="semFundo">Chegada</span>
                    </th>
                    <th class="titulo-coluna" colspan="2">
                        <span class="semFundo">Entrada</span>
                    </th>
                    <th class="titulo-coluna" colspan="2">
                        <span class="semFundo">Saida</span>
                    </th>
                    <!-- <th class="titulo-coluna" colspan="2">
                        <button (click)="sortBy('INT')">Local</button>
                    </th> -->
                </tr>
            </thead>
            <tbody *ngFor="let item of timeTableExcesso">
                <tr>
                    <td [ngClass]="item?.statusEntrega" colspan="2" (click)="editDialog(item)">
                        <label class="labelExcesso">{{ item.Plate }}
                            <span *ngIf="item.idContainer"><abbr
                                    style="color: #000000; font-size: 1.8vh; font-weight: bold;">/ Container: </abbr>
                                {{ item.ID }}<br> </span> </label>
                    </td>
                    <!-- <td class="align-left input-maior">
                            <input type="text" name="Plate" [(ngModel)]="item.Plate" class="modal-input1">
                        </td> -->
                    <td [ngClass]="item?.statusEntrega" colspan="2">
                        <label class="labelExcesso">{{item.Volumes}}</label>
                    </td>
                    <td [ngClass]="item?.statusEntrega" colspan="2">
                        <label class="labelExcesso">{{item.locations}}</label>
                    </td>
                    <!-- <td [ngClass]="item?.statusEntrega" class="align-left input-maior">
                            <input type="text" name="Volumes" [(ngModel)]="item.Volumes" class="modal-input1">
                        </td> -->
                    <td [ngClass]="item?.statusEntrega" colspan="2">
                        <label class="labelExcesso">{{item.Janela}}</label>
                    </td>
                    <!-- <td [ngClass]="item?.statusEntrega" class="align-left input-maior">
                            <input type="text" name="janela" [(ngModel)]="item.janela" class="modal-input1">
                        </td> -->
                    <td [ngClass]="item?.statusEntrega" colspan="2">
                        <label class="labelExcesso"> {{ item.Transportadora == 'LOTS' ? item.Transportadora + ' /
                            Viagem: ' + item.viagem : item.Transportadora }}</label>
                    </td>
                    <td [ngClass]="item?.statusEntrega" colspan="2">
                        <label class="labelExcesso">{{item.Fornecedores}}</label>
                    </td>
                    <td [ngClass]="item?.statusEntrega" colspan="2">
                        <label class="labelExcesso"> {{ item.chegada ? (item?.chegada |
                            date : 'dd/MM/yyyy HH:mm' : '+00:00') : (item?.ChegadaSCANIA | date :
                            'dd/MM/yyyy HH:mm') }}</label>
                    </td>
                    <td [ngClass]="item?.statusEntrega" colspan="2">
                        <label class="labelExcesso"> {{ item.entrada ? (item.entrada | date
                            : 'dd/MM/yyyy HH:mm') : (item?.EntradaSCANIA | date :
                            'dd/MM/yyyy HH:mm') }}</label>
                    </td>
                    <td [ngClass]="item?.statusEntrega" colspan="2">
                        <label class="labelExcesso"> {{ item.saida ? (item.saida | date :
                            'dd/MM/yyyy HH:mm') : (item?.SaidaSCANIA | date :
                            'dd/MM/yyyy HH:mm') }}</label>
                    </td>
                    <!-- <td class="align-left input-maior">
                            <input type="text" name="janela" [(ngModel)]="item.janela" class="modal-input1">
                        </td> -->
                    <!-- <td colspan="2">
                        <label class="labelExcesso">{{item.local}}</label>
                    </td> -->
                    <!-- <td class="align-left input-maior">
                            <input type="text" name="janela" [(ngModel)]="item.janela" class="modal-input1">
                        </td> -->
                </tr>
            </tbody>
        </table>
    </div>
</body>

<clr-modal [(clrModalOpen)]="dialogOpen" [clrModalSize]="'sm'" class="dialog-container">
    <h3 class="modal-title">Detalhes</h3>
    <div class="modal-body">
        <form class="inputs">
            <table class="table2000">
                <tr class="flexEdit">
                    <td>
                        <label class="modal-label">Transportadora</label>
                    </td>
                    <td class="align-left input-maior">
                        <input type="text" name="transportadora" [(ngModel)]="item.transportadora" class="modal-input1">
                        <!-- <input type="text" name="ID" [(ngModel)]="item.ID" class="modal-input1"> -->
                    </td>
                    <td>
                        <label class="modal-label">Placa</label>
                    </td>
                    <td class="align-left input-maior">
                        <input type="text" name="Plate" [(ngModel)]="item.Plate" class="modal-input1">
                    </td>
                    <td>
                        <label class="modal-label">Volumes</label>
                    </td>
                    <td class="align-left input-maior">
                        <input type="text" name="Volumes" [(ngModel)]="item.Volumes" class="modal-input1">
                    </td>
                </tr>
                <tr class="flexEdit">
                    <td *ngIf="edit2">
                        <label class="modal-label">Destino 1</label>
                    </td>
                    <td class="align-left input-maior" *ngIf="edit2">
                        <input type="text" name="forn1" [(ngModel)]="item.forn1" class="modal-input1">
                    </td>
                    <td>
                        <label class="modal-label">Janela 1</label>
                    </td>
                    <td class="align-left input-maior">
                        <!-- <input *ngIf="!edit2" type="text" name="jan1" [(ngModel)]="item.jan1" class="modal-input1"> -->
                        <input [disabled]="this.usuarioLogado.role != '2' && this.usuarioLogado.role != '9'" type="date" name="dataJanela" [(ngModel)]="item.dataJanela" class="modal-input1">
                        <input [disabled]="this.usuarioLogado.role != '2' && this.usuarioLogado.role != '9'" type="time" name="horaJanela" [(ngModel)]="item.horaJanela" class="modal-input1">
                    </td>
                </tr>
                <tr class="flexEdit">
                    <td>
                        <label class="modal-label">Nº Container</label>
                    </td>
                    <td class="align-left input-maior">
                        <input type="text" name="idContainer" [(ngModel)]="item.idContainer" class="modal-input1">
                    </td>
                </tr>
                <tr class="flexEdit" *ngIf="item.forn2">
                    <td>
                        <label class="modal-label">Destino 2</label>
                    </td>
                    <td class="align-left input-maior">
                        <input type="text" name="forn2" [(ngModel)]="item.forn2" class="modal-input1">
                    </td>
                    <td>
                        <label class="modal-label">Janela 2</label>
                    </td>
                    <td class="align-left input-maior">
                        <input [disabled]="this.usuarioLogado.role != '2' && this.usuarioLogado.role != '9'" type="text" name="jan2" [(ngModel)]="item.jan2" class="modal-input1">
                    </td>
                </tr>
                <tr class="flexEdit" *ngIf="item.forn3">
                    <td>
                        <label class="modal-label">Destino 3</label>
                    </td>
                    <td class="align-left input-maior">
                        <input type="text" name="forn3" [(ngModel)]="item.forn3" class="modal-input1">
                    </td>
                    <td>
                        <label class="modal-label">Janela 3</label>
                    </td>
                    <td class="align-left input-maior">
                        <input [disabled]="this.usuarioLogado.role != '2' && this.usuarioLogado.role != '9'" type="text" name="jan3" [(ngModel)]="item.jan3" class="modal-input1">
                    </td>
                </tr>
                <tr class="flexEdit" *ngIf="item.forn4">
                    <!-- <td>
                        <label class="modal-label">Destino 4</label>
                    </td>
                    <td class="align-left input-maior">
                        <input type="text" name="forn4" [(ngModel)]="item.forn4" class="modal-input1">
                    </td> -->
                    <td>
                        <label class="modal-label">Janela 4</label>
                    </td>
                    <td class="align-left input-maior">
                        <input [disabled]="this.usuarioLogado.role != '2' && this.usuarioLogado.role != '9'" type="text" name="jan4" [(ngModel)]="item.jan4" class="modal-input1">
                    </td>
                </tr>
                <tr class="flexEdit">
                    <td>
                        <label class="modal-label">Fornecedores</label>
                    </td>
                    <td class="align-left input-maior">
                        <input type="text" name="Fornecedores" [(ngModel)]="item['Fornecedores']" class="modal-input1">
                    </td>
                    <td>
                        <label class="modal-label">Local</label>
                    </td>
                    <td class="align-left input-maior">
                        <input type="text" name="locations" [(ngModel)]="item['locations']" class="modal-input1">
                    </td>
                </tr>
                <!-- <tr *ngIf="item['Fornecedor 2']" class="flexEdit">
                    <td>
                        <label class="modal-label">Fornecedor 2</label>
                    </td>
                    <td class="align-left input-maior">
                        <input type="text" name="Fornecedor 2" [(ngModel)]="item['Fornecedor 2']" class="modal-input1">
                    </td>
                    <td>
                        <label class="modal-label">Local</label>
                    </td>
                    <td class="align-left input-maior">
                        <input type="text" name="location2" [(ngModel)]="item['location2']" class="modal-input1">
                    </td>
                </tr>
                <tr *ngIf="item['Fornecedor 3']" class="flexEdit">
                    <td>
                        <label class="modal-label">Fornecedor 3</label>
                    </td>
                    <td class="align-left input-maior">
                        <input type="text" name="Fornecedor 3" [(ngModel)]="item['Fornecedor 3']" class="modal-input1">
                    </td>
                    <td>
                        <label class="modal-label">Local</label>
                    </td>
                    <td class="align-left input-maior">
                        <input type="text" name="location3" [(ngModel)]="item['location3']" class="modal-input1">
                    </td>
                </tr>
                <tr *ngIf="item['Fornecedor 4']" class="flexEdit">
                    <td>
                        <label class="modal-label">Fornecedor 4</label>
                    </td>
                    <td class="align-left input-maior">
                        <input type="text" name="Fornecedor 4" [(ngModel)]="item['Fornecedor 4']" class="modal-input1">
                    </td>
                    <td>
                        <label class="modal-label">Local</label>
                    </td>
                    <td class="align-left input-maior">
                        <input type="text" name="location4" [(ngModel)]="item['location4']" class="modal-input1">
                    </td>
                </tr> -->
            </table>
            <div class="modal-div botoes">
                <button *ngIf="!edit2" class="modal-button" type="button" (click)="reservaEmbalagem(item)">Coletar
                    Embalagem</button>
                <button *ngIf="!edit2" class="modal-button" type="button" (click)="reutilizarEXP(item)">Reutilizar
                    Container</button>
                <button *ngIf="!edit2" class="modal-button" type="button" (click)="deleteItem(item)">Cancelar
                    Reserva</button>
                <button *ngIf="!edit2" [disabled]="isCarrierEnabled" class="modal-button" type="button"
                    (click)="FinalizarViagem(item)">Finalizar Viagem</button>
                <button class="modal-button" type="button" (click)="salvar()">Save</button>
                <button class="modal-button" type="button" (click)="cancel()">Cancel</button>
                <!-- <input  type="checkbox" name="coletaEmbalagem" [(ngModel)]="item.coletaEmbalagem" class="modal-input1"><abbr  style="color: #dbdbdb; font-size: 1.8vh; font-weight: bold;">Coletar Embalagem</abbr> -->
                <button *ngIf="!edit2" [disabled]="isCarrierEnabled" class="modal-button" type="button"
                    (click)="deleteItem(item)">Delete</button>
            </div>
        </form>
    </div>
</clr-modal>


<div *ngIf="!totalMR || isLoading" class="spinner-overlay">
    <div class="spinner">
        <mat-spinner></mat-spinner>
    </div>
</div>